/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminEntitlementResponse,
  AdminEntitlementsPageResponse,
  AdminGetBroadcastNotificationsParams,
  AdminGetBroadcastsParams,
  AdminGetConsultantHoursTransactionsParams,
  AdminGetStripeCustomersParams,
  AdminGetStripeProductsParams,
  AdminGetStripeSubscriptionsParams,
  AdminInvitationResponse,
  AdminListOrganizationCurrentPartnerHistoryParams,
  AdminListOrganizationsParams,
  AdminListProductEntitlementsParams,
  AdminListProductRegistrationHistoryParams,
  AdminListProductRegistrationsParams,
  AdminListSystemNoticesParams,
  AdminListUserRolesParams,
  AdminListUsersParams,
  AdminOrganizationCurrentPartnerHistoryPageResponse,
  AdminOrganizationResponse,
  AdminOrganizationsPageResponse,
  AdminProductRegistrationHistoryPageResponse,
  AdminProductRegistrationsPageResponse,
  AdminUserRolesPageResponse,
  AdminUsersPageResponse,
  AuditEventsResponse,
  BroadcastDryRunResponse,
  BroadcastFilterDetailResponse,
  BroadcastListResponse,
  BroadcastNotificationsResponse,
  BroadcastResponse,
  BroadcastTriggerResponse,
  ConsultantHourPackageResponse,
  ConsultantHourPackagesListResponse,
  ConsultantHoursTransactionResponse,
  ConsultantHoursTransactionsListResponse,
  CreateBroadcastFilterRequest,
  CreateBroadcastRequest,
  CreateConsultantHourPackageRequest,
  CreateConsultantHoursTransactionRequest,
  CreateDefaultEntitlementRequest,
  CreateFeatureTagRequest,
  CreateInvitationAdminRequest,
  CreateLegalDocumentVersionRequest,
  CreateNotificationTemplateRequest,
  CreateOrganizationAdminRequest,
  CreateProductRequest,
  CreateProductTrialRequest,
  CreateStripePriceEntitlementRequest,
  CreateSystemNoticeRequest,
  DefaultEntitlementResponse,
  FeatureTagResponse,
  FeatureTagsListResponse,
  GetAuditParams,
  GrantEntitlementAdminRequest,
  LegalDocumentLinkResponse,
  LegalDocumentVersionListResponse,
  LegalDocumentVersionResponse,
  LegalDocumentsListResponse,
  NotificationTemplateListResponse,
  NotificationTemplateResponse,
  ProblemDetails,
  ProductRegistrationResponse,
  ProductResponse,
  ProductTrialResponse,
  ProductTrialsListResponse,
  ProductsListResponse,
  SendTestNotificationRequest,
  StripeCustomersListResponse,
  StripePriceEntitlementResponse,
  StripePriceEntitlementsListResponse,
  StripeProductLocalizationResponse,
  StripeProductResponse,
  StripeProductsListResponse,
  StripeSubscriptionsListResponse,
  StripeSyncOrchestrationStatus,
  SyncStatusResponse,
  SyncTriggeredResponse,
  SystemNoticeResponse,
  UpdateBroadcastFilterRequest,
  UpdateBroadcastRequest,
  UpdateConsultantHourPackageRequest,
  UpdateConsultantHoursTransactionRequest,
  UpdateDefaultEntitlementRequest,
  UpdateEntitlementAdminRequest,
  UpdateFeatureTagRequest,
  UpdateNotificationTemplateRequest,
  UpdateOrganizationAdminRequest,
  UpdateOrganizationCurrentPartnerAdminRequest,
  UpdateOrganizationFeaturesAdminRequest,
  UpdateOrganizationSourcePartnerAdminRequest,
  UpdateProductRequest,
  UpdateStripePriceEntitlementRequest,
  UpdateSystemNoticeRequest,
  UpsertLegalDocumentLinkRequest,
  UpsertNotificationTemplateContentRequest,
  UpsertStripeProductLocalizationRequest,
} from '../missionImpactAuthAPI.schemas';

import { instance } from '../../mutator-auth';
import type { ErrorType } from '../../mutator-auth';

/**
 * Returns paginated audit events with optional filtering. Requires Admin scope.
 * @summary Get audit events
 */
export const getAudit = (orgId: string, params?: GetAuditParams, signal?: AbortSignal) => {
  return instance<AuditEventsResponse>({
    url: `/v1/org/${orgId}/audit`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAuditQueryKey = (orgId?: string, params?: GetAuditParams) => {
  return [`/v1/org/${orgId}/audit`, ...(params ? [params] : [])] as const;
};

export const getGetAuditQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudit>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: GetAuditParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudit>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuditQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudit>>> = ({ signal }) =>
    getAudit(orgId, params, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAuditQueryResult = NonNullable<Awaited<ReturnType<typeof getAudit>>>;
export type GetAuditQueryError = ErrorType<ProblemDetails>;

export function useGetAudit<
  TData = Awaited<ReturnType<typeof getAudit>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params: undefined | GetAuditParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudit>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudit>>,
          TError,
          Awaited<ReturnType<typeof getAudit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAudit<
  TData = Awaited<ReturnType<typeof getAudit>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: GetAuditParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudit>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAudit>>,
          TError,
          Awaited<ReturnType<typeof getAudit>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAudit<
  TData = Awaited<ReturnType<typeof getAudit>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: GetAuditParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudit>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get audit events
 */

export function useGetAudit<
  TData = Awaited<ReturnType<typeof getAudit>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: GetAuditParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudit>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAuditQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new broadcast notification in draft status. Requires Admin role.
 * @summary Create broadcast
 */
export const adminCreateBroadcast = (
  createBroadcastRequest: CreateBroadcastRequest,
  signal?: AbortSignal
) => {
  return instance<BroadcastResponse>({
    url: `/v1/admin/broadcasts`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createBroadcastRequest,
    signal,
  });
};

export const getAdminCreateBroadcastMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateBroadcast>>,
    TError,
    { data: CreateBroadcastRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateBroadcast>>,
  TError,
  { data: CreateBroadcastRequest },
  TContext
> => {
  const mutationKey = ['adminCreateBroadcast'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateBroadcast>>,
    { data: CreateBroadcastRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateBroadcast(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateBroadcast>>
>;
export type AdminCreateBroadcastMutationBody = CreateBroadcastRequest;
export type AdminCreateBroadcastMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create broadcast
 */
export const useAdminCreateBroadcast = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateBroadcast>>,
      TError,
      { data: CreateBroadcastRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateBroadcast>>,
  TError,
  { data: CreateBroadcastRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateBroadcastMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets a paginated list of broadcast notifications. Requires Admin role.
 * @summary List broadcasts
 */
export const adminGetBroadcasts = (params?: AdminGetBroadcastsParams, signal?: AbortSignal) => {
  return instance<BroadcastListResponse>({
    url: `/v1/admin/broadcasts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetBroadcastsQueryKey = (params?: AdminGetBroadcastsParams) => {
  return [`/v1/admin/broadcasts`, ...(params ? [params] : [])] as const;
};

export const getAdminGetBroadcastsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetBroadcasts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetBroadcastsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcasts>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetBroadcastsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetBroadcasts>>> = ({ signal }) =>
    adminGetBroadcasts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBroadcasts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetBroadcastsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetBroadcasts>>
>;
export type AdminGetBroadcastsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetBroadcasts<
  TData = Awaited<ReturnType<typeof adminGetBroadcasts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminGetBroadcastsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcasts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcasts>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcasts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcasts<
  TData = Awaited<ReturnType<typeof adminGetBroadcasts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetBroadcastsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcasts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcasts>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcasts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcasts<
  TData = Awaited<ReturnType<typeof adminGetBroadcasts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetBroadcastsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcasts>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List broadcasts
 */

export function useAdminGetBroadcasts<
  TData = Awaited<ReturnType<typeof adminGetBroadcasts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetBroadcastsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcasts>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetBroadcastsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a broadcast notification by ID. Requires Admin role.
 * @summary Get broadcast
 */
export const adminGetBroadcast = (broadcastId: string, signal?: AbortSignal) => {
  return instance<BroadcastResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetBroadcastQueryKey = (broadcastId?: string) => {
  return [`/v1/admin/broadcasts/${broadcastId}`] as const;
};

export const getAdminGetBroadcastQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetBroadcast>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcast>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetBroadcastQueryKey(broadcastId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetBroadcast>>> = ({ signal }) =>
    adminGetBroadcast(broadcastId, signal);

  return { queryKey, queryFn, enabled: !!broadcastId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBroadcast>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetBroadcastQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetBroadcast>>
>;
export type AdminGetBroadcastQueryError = ErrorType<ProblemDetails>;

export function useAdminGetBroadcast<
  TData = Awaited<ReturnType<typeof adminGetBroadcast>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcast>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcast>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcast>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcast<
  TData = Awaited<ReturnType<typeof adminGetBroadcast>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcast>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcast>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcast>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcast<
  TData = Awaited<ReturnType<typeof adminGetBroadcast>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcast>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get broadcast
 */

export function useAdminGetBroadcast<
  TData = Awaited<ReturnType<typeof adminGetBroadcast>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcast>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetBroadcastQueryOptions(broadcastId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a broadcast notification. Only allowed for draft broadcasts. Requires Admin role.
 * @summary Update broadcast
 */
export const adminUpdateBroadcast = (
  broadcastId: string,
  updateBroadcastRequest: UpdateBroadcastRequest
) => {
  return instance<BroadcastResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateBroadcastRequest,
  });
};

export const getAdminUpdateBroadcastMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateBroadcast>>,
    TError,
    { broadcastId: string; data: UpdateBroadcastRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateBroadcast>>,
  TError,
  { broadcastId: string; data: UpdateBroadcastRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateBroadcast'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateBroadcast>>,
    { broadcastId: string; data: UpdateBroadcastRequest }
  > = (props) => {
    const { broadcastId, data } = props ?? {};

    return adminUpdateBroadcast(broadcastId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateBroadcast>>
>;
export type AdminUpdateBroadcastMutationBody = UpdateBroadcastRequest;
export type AdminUpdateBroadcastMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update broadcast
 */
export const useAdminUpdateBroadcast = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateBroadcast>>,
      TError,
      { broadcastId: string; data: UpdateBroadcastRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateBroadcast>>,
  TError,
  { broadcastId: string; data: UpdateBroadcastRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateBroadcastMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a broadcast notification. Only allowed for draft broadcasts. Requires Admin role.
 * @summary Delete broadcast
 */
export const adminDeleteBroadcast = (broadcastId: string) => {
  return instance<void>({ url: `/v1/admin/broadcasts/${broadcastId}`, method: 'DELETE' });
};

export const getAdminDeleteBroadcastMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteBroadcast>>,
    TError,
    { broadcastId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteBroadcast'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteBroadcast>>,
    { broadcastId: string }
  > = (props) => {
    const { broadcastId } = props ?? {};

    return adminDeleteBroadcast(broadcastId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteBroadcast>>
>;

export type AdminDeleteBroadcastMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete broadcast
 */
export const useAdminDeleteBroadcast = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteBroadcast>>,
      TError,
      { broadcastId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteBroadcastMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Executes a dry-run of the broadcast to preview recipients without sending any notifications. Uses the same orchestrator logic as the real trigger for consistency. Requires Admin role.
 * @summary Dry-run broadcast
 */
export const adminDryRunBroadcast = (broadcastId: string, signal?: AbortSignal) => {
  return instance<BroadcastDryRunResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}/dry-run`,
    method: 'POST',
    signal,
  });
};

export const getAdminDryRunBroadcastMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDryRunBroadcast>>,
    TError,
    { broadcastId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDryRunBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationKey = ['adminDryRunBroadcast'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDryRunBroadcast>>,
    { broadcastId: string }
  > = (props) => {
    const { broadcastId } = props ?? {};

    return adminDryRunBroadcast(broadcastId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDryRunBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDryRunBroadcast>>
>;

export type AdminDryRunBroadcastMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Dry-run broadcast
 */
export const useAdminDryRunBroadcast = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDryRunBroadcast>>,
      TError,
      { broadcastId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDryRunBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationOptions = getAdminDryRunBroadcastMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Triggers a broadcast to send notifications to all resolved recipients. Returns immediately with an orchestration instance ID for status tracking. Requires Admin role.
 * @summary Trigger broadcast
 */
export const adminTriggerBroadcast = (broadcastId: string, signal?: AbortSignal) => {
  return instance<BroadcastTriggerResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}/trigger`,
    method: 'POST',
    signal,
  });
};

export const getAdminTriggerBroadcastMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTriggerBroadcast>>,
    TError,
    { broadcastId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTriggerBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationKey = ['adminTriggerBroadcast'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTriggerBroadcast>>,
    { broadcastId: string }
  > = (props) => {
    const { broadcastId } = props ?? {};

    return adminTriggerBroadcast(broadcastId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTriggerBroadcastMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminTriggerBroadcast>>
>;

export type AdminTriggerBroadcastMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Trigger broadcast
 */
export const useAdminTriggerBroadcast = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminTriggerBroadcast>>,
      TError,
      { broadcastId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminTriggerBroadcast>>,
  TError,
  { broadcastId: string },
  TContext
> => {
  const mutationOptions = getAdminTriggerBroadcastMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Adds a filter to a broadcast notification. Only allowed for draft broadcasts. Requires Admin role.
 * @summary Add broadcast filter
 */
export const adminAddBroadcastFilter = (
  broadcastId: string,
  createBroadcastFilterRequest: CreateBroadcastFilterRequest,
  signal?: AbortSignal
) => {
  return instance<BroadcastFilterDetailResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}/filters`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createBroadcastFilterRequest,
    signal,
  });
};

export const getAdminAddBroadcastFilterMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAddBroadcastFilter>>,
    TError,
    { broadcastId: string; data: CreateBroadcastFilterRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminAddBroadcastFilter>>,
  TError,
  { broadcastId: string; data: CreateBroadcastFilterRequest },
  TContext
> => {
  const mutationKey = ['adminAddBroadcastFilter'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminAddBroadcastFilter>>,
    { broadcastId: string; data: CreateBroadcastFilterRequest }
  > = (props) => {
    const { broadcastId, data } = props ?? {};

    return adminAddBroadcastFilter(broadcastId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAddBroadcastFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminAddBroadcastFilter>>
>;
export type AdminAddBroadcastFilterMutationBody = CreateBroadcastFilterRequest;
export type AdminAddBroadcastFilterMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Add broadcast filter
 */
export const useAdminAddBroadcastFilter = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminAddBroadcastFilter>>,
      TError,
      { broadcastId: string; data: CreateBroadcastFilterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminAddBroadcastFilter>>,
  TError,
  { broadcastId: string; data: CreateBroadcastFilterRequest },
  TContext
> => {
  const mutationOptions = getAdminAddBroadcastFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates a filter on a broadcast notification. Only allowed for draft broadcasts. Requires Admin role.
 * @summary Update broadcast filter
 */
export const adminUpdateBroadcastFilter = (
  broadcastId: string,
  filterId: string,
  updateBroadcastFilterRequest: UpdateBroadcastFilterRequest
) => {
  return instance<BroadcastFilterDetailResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}/filters/${filterId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateBroadcastFilterRequest,
  });
};

export const getAdminUpdateBroadcastFilterMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>,
    TError,
    { broadcastId: string; filterId: string; data: UpdateBroadcastFilterRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>,
  TError,
  { broadcastId: string; filterId: string; data: UpdateBroadcastFilterRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateBroadcastFilter'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>,
    { broadcastId: string; filterId: string; data: UpdateBroadcastFilterRequest }
  > = (props) => {
    const { broadcastId, filterId, data } = props ?? {};

    return adminUpdateBroadcastFilter(broadcastId, filterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateBroadcastFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>
>;
export type AdminUpdateBroadcastFilterMutationBody = UpdateBroadcastFilterRequest;
export type AdminUpdateBroadcastFilterMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update broadcast filter
 */
export const useAdminUpdateBroadcastFilter = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>,
      TError,
      { broadcastId: string; filterId: string; data: UpdateBroadcastFilterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateBroadcastFilter>>,
  TError,
  { broadcastId: string; filterId: string; data: UpdateBroadcastFilterRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateBroadcastFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a filter from a broadcast notification. Only allowed for draft broadcasts. Requires Admin role.
 * @summary Delete broadcast filter
 */
export const adminDeleteBroadcastFilter = (broadcastId: string, filterId: string) => {
  return instance<void>({
    url: `/v1/admin/broadcasts/${broadcastId}/filters/${filterId}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteBroadcastFilterMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>,
    TError,
    { broadcastId: string; filterId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>,
  TError,
  { broadcastId: string; filterId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteBroadcastFilter'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>,
    { broadcastId: string; filterId: string }
  > = (props) => {
    const { broadcastId, filterId } = props ?? {};

    return adminDeleteBroadcastFilter(broadcastId, filterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteBroadcastFilterMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>
>;

export type AdminDeleteBroadcastFilterMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete broadcast filter
 */
export const useAdminDeleteBroadcastFilter = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>,
      TError,
      { broadcastId: string; filterId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteBroadcastFilter>>,
  TError,
  { broadcastId: string; filterId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteBroadcastFilterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets a paginated list of notifications for a broadcast. Requires Admin role.
 * @summary Get broadcast notifications
 */
export const adminGetBroadcastNotifications = (
  broadcastId: string,
  params?: AdminGetBroadcastNotificationsParams,
  signal?: AbortSignal
) => {
  return instance<BroadcastNotificationsResponse>({
    url: `/v1/admin/broadcasts/${broadcastId}/notifications`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetBroadcastNotificationsQueryKey = (
  broadcastId?: string,
  params?: AdminGetBroadcastNotificationsParams
) => {
  return [
    `/v1/admin/broadcasts/${broadcastId}/notifications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetBroadcastNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  params?: AdminGetBroadcastNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetBroadcastNotificationsQueryKey(broadcastId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>> = ({
    signal,
  }) => adminGetBroadcastNotifications(broadcastId, params, signal);

  return { queryKey, queryFn, enabled: !!broadcastId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetBroadcastNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetBroadcastNotifications>>
>;
export type AdminGetBroadcastNotificationsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetBroadcastNotifications<
  TData = Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  params: undefined | AdminGetBroadcastNotificationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcastNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcastNotifications<
  TData = Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  params?: AdminGetBroadcastNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
          TError,
          Awaited<ReturnType<typeof adminGetBroadcastNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetBroadcastNotifications<
  TData = Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  params?: AdminGetBroadcastNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get broadcast notifications
 */

export function useAdminGetBroadcastNotifications<
  TData = Awaited<ReturnType<typeof adminGetBroadcastNotifications>>,
  TError = ErrorType<ProblemDetails>,
>(
  broadcastId: string,
  params?: AdminGetBroadcastNotificationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetBroadcastNotifications>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetBroadcastNotificationsQueryOptions(broadcastId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Records a Credit (adds hours) or Debit (consumes hours) against an organization's consultant hours ledger and updates the organization's consultantHoursAssigned, consultantHoursSpent and consultantHoursAvailable totals atomically. Hours must be greater than 0 with at most two decimal places. A debit that exceeds the available hours is rejected with 409. Ledger entries are immutable; correct a mistake by recording an opposite entry. Requires Admin role.
 * @summary Credit or debit consultant hours (admin)
 */
export const adminCreateConsultantHoursTransaction = (
  orgId: string,
  createConsultantHoursTransactionRequest: CreateConsultantHoursTransactionRequest,
  signal?: AbortSignal
) => {
  return instance<ConsultantHoursTransactionResponse>({
    url: `/v1/admin/organizations/${orgId}/consultant-hours/transactions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createConsultantHoursTransactionRequest,
    signal,
  });
};

export const getAdminCreateConsultantHoursTransactionMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>,
    TError,
    { orgId: string; data: CreateConsultantHoursTransactionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>,
  TError,
  { orgId: string; data: CreateConsultantHoursTransactionRequest },
  TContext
> => {
  const mutationKey = ['adminCreateConsultantHoursTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>,
    { orgId: string; data: CreateConsultantHoursTransactionRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminCreateConsultantHoursTransaction(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateConsultantHoursTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>
>;
export type AdminCreateConsultantHoursTransactionMutationBody =
  CreateConsultantHoursTransactionRequest;
export type AdminCreateConsultantHoursTransactionMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Credit or debit consultant hours (admin)
 */
export const useAdminCreateConsultantHoursTransaction = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>,
      TError,
      { orgId: string; data: CreateConsultantHoursTransactionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateConsultantHoursTransaction>>,
  TError,
  { orgId: string; data: CreateConsultantHoursTransactionRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateConsultantHoursTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets a page of an organization's consultant hours ledger (credits and debits) ordered by creation date descending. Requires Admin role.
 * @summary List consultant hours transactions (admin)
 */
export const adminGetConsultantHoursTransactions = (
  orgId: string,
  params?: AdminGetConsultantHoursTransactionsParams,
  signal?: AbortSignal
) => {
  return instance<ConsultantHoursTransactionsListResponse>({
    url: `/v1/admin/organizations/${orgId}/consultant-hours/transactions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetConsultantHoursTransactionsQueryKey = (
  orgId?: string,
  params?: AdminGetConsultantHoursTransactionsParams
) => {
  return [
    `/v1/admin/organizations/${orgId}/consultant-hours/transactions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetConsultantHoursTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: AdminGetConsultantHoursTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetConsultantHoursTransactionsQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>> = ({
    signal,
  }) => adminGetConsultantHoursTransactions(orgId, params, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetConsultantHoursTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>
>;
export type AdminGetConsultantHoursTransactionsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetConsultantHoursTransactions<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params: undefined | AdminGetConsultantHoursTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHoursTransactions<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: AdminGetConsultantHoursTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHoursTransactions<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: AdminGetConsultantHoursTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List consultant hours transactions (admin)
 */

export function useAdminGetConsultantHoursTransactions<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  params?: AdminGetConsultantHoursTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetConsultantHoursTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetConsultantHoursTransactionsQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a single consultant hours ledger entry of an organization. Requires Admin role.
 * @summary Get consultant hours transaction (admin)
 */
export const adminGetConsultantHoursTransaction = (
  orgId: string,
  transactionId: string,
  signal?: AbortSignal
) => {
  return instance<ConsultantHoursTransactionResponse>({
    url: `/v1/admin/organizations/${orgId}/consultant-hours/transactions/${transactionId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetConsultantHoursTransactionQueryKey = (
  orgId?: string,
  transactionId?: string
) => {
  return [
    `/v1/admin/organizations/${orgId}/consultant-hours/transactions/${transactionId}`,
  ] as const;
};

export const getAdminGetConsultantHoursTransactionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  transactionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetConsultantHoursTransactionQueryKey(orgId, transactionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>> = ({
    signal,
  }) => adminGetConsultantHoursTransaction(orgId, transactionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && transactionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetConsultantHoursTransactionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>
>;
export type AdminGetConsultantHoursTransactionQueryError = ErrorType<ProblemDetails>;

export function useAdminGetConsultantHoursTransaction<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  transactionId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHoursTransaction<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  transactionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHoursTransaction<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  transactionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get consultant hours transaction (admin)
 */

export function useAdminGetConsultantHoursTransaction<
  TData = Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  transactionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHoursTransaction>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetConsultantHoursTransactionQueryOptions(
    orgId,
    transactionId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Applies a partial update to a ledger entry's type, hours and/or description (an empty description clears it). The organization's consultantHoursAssigned, consultantHoursSpent and consultantHoursAvailable totals, and every entry's availableHoursAfter, are recomputed from the full ledger in the same transaction; the totals cannot be set directly. Rejected with 409 when the edit would make available hours negative at any point in the ledger, or would change the hours or type of a Stripe package purchase. Requires Admin role.
 * @summary Update consultant hours transaction (admin)
 */
export const adminUpdateConsultantHoursTransaction = (
  orgId: string,
  transactionId: string,
  updateConsultantHoursTransactionRequest: UpdateConsultantHoursTransactionRequest
) => {
  return instance<ConsultantHoursTransactionResponse>({
    url: `/v1/admin/organizations/${orgId}/consultant-hours/transactions/${transactionId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateConsultantHoursTransactionRequest,
  });
};

export const getAdminUpdateConsultantHoursTransactionMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>,
    TError,
    { orgId: string; transactionId: string; data: UpdateConsultantHoursTransactionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>,
  TError,
  { orgId: string; transactionId: string; data: UpdateConsultantHoursTransactionRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateConsultantHoursTransaction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>,
    { orgId: string; transactionId: string; data: UpdateConsultantHoursTransactionRequest }
  > = (props) => {
    const { orgId, transactionId, data } = props ?? {};

    return adminUpdateConsultantHoursTransaction(orgId, transactionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateConsultantHoursTransactionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>
>;
export type AdminUpdateConsultantHoursTransactionMutationBody =
  UpdateConsultantHoursTransactionRequest;
export type AdminUpdateConsultantHoursTransactionMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update consultant hours transaction (admin)
 */
export const useAdminUpdateConsultantHoursTransaction = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>,
      TError,
      { orgId: string; transactionId: string; data: UpdateConsultantHoursTransactionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateConsultantHoursTransaction>>,
  TError,
  { orgId: string; transactionId: string; data: UpdateConsultantHoursTransactionRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateConsultantHoursTransactionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new default entitlement for a product. Requires Admin role.
 * @summary Create default entitlement
 */
export const adminCreateDefaultEntitlement = (
  productId: string,
  createDefaultEntitlementRequest: CreateDefaultEntitlementRequest,
  signal?: AbortSignal
) => {
  return instance<DefaultEntitlementResponse>({
    url: `/v1/admin/products/${productId}/default-entitlement`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDefaultEntitlementRequest,
    signal,
  });
};

export const getAdminCreateDefaultEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>,
    TError,
    { productId: string; data: CreateDefaultEntitlementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>,
  TError,
  { productId: string; data: CreateDefaultEntitlementRequest },
  TContext
> => {
  const mutationKey = ['adminCreateDefaultEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>,
    { productId: string; data: CreateDefaultEntitlementRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminCreateDefaultEntitlement(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateDefaultEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>
>;
export type AdminCreateDefaultEntitlementMutationBody = CreateDefaultEntitlementRequest;
export type AdminCreateDefaultEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create default entitlement
 */
export const useAdminCreateDefaultEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>,
      TError,
      { productId: string; data: CreateDefaultEntitlementRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateDefaultEntitlement>>,
  TError,
  { productId: string; data: CreateDefaultEntitlementRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateDefaultEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all default entitlements for a product. Requires Admin role.
 * @summary List product default entitlements
 */
export const adminGetProductDefaultEntitlements = (productId: string, signal?: AbortSignal) => {
  return instance<DefaultEntitlementResponse>({
    url: `/v1/admin/products/${productId}/default-entitlement`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetProductDefaultEntitlementsQueryKey = (productId?: string) => {
  return [`/v1/admin/products/${productId}/default-entitlement`] as const;
};

export const getAdminGetProductDefaultEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetProductDefaultEntitlementsQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>> = ({
    signal,
  }) => adminGetProductDefaultEntitlements(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetProductDefaultEntitlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>
>;
export type AdminGetProductDefaultEntitlementsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetProductDefaultEntitlements<
  TData = Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductDefaultEntitlements<
  TData = Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductDefaultEntitlements<
  TData = Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List product default entitlements
 */

export function useAdminGetProductDefaultEntitlements<
  TData = Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductDefaultEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetProductDefaultEntitlementsQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a default entitlement. Requires Admin role.
 * @summary Update default entitlement
 */
export const adminUpdateDefaultEntitlement = (
  productId: string,
  updateDefaultEntitlementRequest: UpdateDefaultEntitlementRequest
) => {
  return instance<DefaultEntitlementResponse>({
    url: `/v1/admin/${productId}/default-entitlement`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateDefaultEntitlementRequest,
  });
};

export const getAdminUpdateDefaultEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>,
    TError,
    { productId: string; data: UpdateDefaultEntitlementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>,
  TError,
  { productId: string; data: UpdateDefaultEntitlementRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateDefaultEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>,
    { productId: string; data: UpdateDefaultEntitlementRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminUpdateDefaultEntitlement(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateDefaultEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>
>;
export type AdminUpdateDefaultEntitlementMutationBody = UpdateDefaultEntitlementRequest;
export type AdminUpdateDefaultEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update default entitlement
 */
export const useAdminUpdateDefaultEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>,
      TError,
      { productId: string; data: UpdateDefaultEntitlementRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateDefaultEntitlement>>,
  TError,
  { productId: string; data: UpdateDefaultEntitlementRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateDefaultEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a default entitlement. Requires Admin role.
 * @summary Delete default entitlement
 */
export const adminDeleteDefaultEntitlement = (productId: string) => {
  return instance<DefaultEntitlementResponse>({
    url: `/v1/admin/${productId}/default-entitlement`,
    method: 'DELETE',
  });
};

export const getAdminDeleteDefaultEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>,
    TError,
    { productId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>,
  TError,
  { productId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteDefaultEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>,
    { productId: string }
  > = (props) => {
    const { productId } = props ?? {};

    return adminDeleteDefaultEntitlement(productId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteDefaultEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>
>;

export type AdminDeleteDefaultEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete default entitlement
 */
export const useAdminDeleteDefaultEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>,
      TError,
      { productId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteDefaultEntitlement>>,
  TError,
  { productId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteDefaultEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new feature catalog tag (product + feature code + description). The feature code must be globally unique and the product must exist. Requires Admin role.
 * @summary Create feature tag
 */
export const adminCreateFeatureTag = (
  createFeatureTagRequest: CreateFeatureTagRequest,
  signal?: AbortSignal
) => {
  return instance<FeatureTagResponse>({
    url: `/v1/admin/feature-tags`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createFeatureTagRequest,
    signal,
  });
};

export const getAdminCreateFeatureTagMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateFeatureTag>>,
    TError,
    { data: CreateFeatureTagRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateFeatureTag>>,
  TError,
  { data: CreateFeatureTagRequest },
  TContext
> => {
  const mutationKey = ['adminCreateFeatureTag'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateFeatureTag>>,
    { data: CreateFeatureTagRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateFeatureTag(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateFeatureTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateFeatureTag>>
>;
export type AdminCreateFeatureTagMutationBody = CreateFeatureTagRequest;
export type AdminCreateFeatureTagMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create feature tag
 */
export const useAdminCreateFeatureTag = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateFeatureTag>>,
      TError,
      { data: CreateFeatureTagRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateFeatureTag>>,
  TError,
  { data: CreateFeatureTagRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateFeatureTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all feature catalog tags ordered by product and feature code. Requires Admin role.
 * @summary List feature tags
 */
export const adminGetFeatureTags = (signal?: AbortSignal) => {
  return instance<FeatureTagsListResponse>({
    url: `/v1/admin/feature-tags`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetFeatureTagsQueryKey = () => {
  return [`/v1/admin/feature-tags`] as const;
};

export const getAdminGetFeatureTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetFeatureTags>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTags>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetFeatureTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetFeatureTags>>> = ({ signal }) =>
    adminGetFeatureTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetFeatureTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetFeatureTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetFeatureTags>>
>;
export type AdminGetFeatureTagsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetFeatureTags<
  TData = Awaited<ReturnType<typeof adminGetFeatureTags>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetFeatureTags>>,
          TError,
          Awaited<ReturnType<typeof adminGetFeatureTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetFeatureTags<
  TData = Awaited<ReturnType<typeof adminGetFeatureTags>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetFeatureTags>>,
          TError,
          Awaited<ReturnType<typeof adminGetFeatureTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetFeatureTags<
  TData = Awaited<ReturnType<typeof adminGetFeatureTags>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List feature tags
 */

export function useAdminGetFeatureTags<
  TData = Awaited<ReturnType<typeof adminGetFeatureTags>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetFeatureTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a feature catalog tag by ID. Requires Admin role.
 * @summary Get feature tag
 */
export const adminGetFeatureTag = (featureTagId: string, signal?: AbortSignal) => {
  return instance<FeatureTagResponse>({
    url: `/v1/admin/feature-tags/${featureTagId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetFeatureTagQueryKey = (featureTagId?: string) => {
  return [`/v1/admin/feature-tags/${featureTagId}`] as const;
};

export const getAdminGetFeatureTagQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetFeatureTag>>,
  TError = ErrorType<ProblemDetails>,
>(
  featureTagId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTag>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetFeatureTagQueryKey(featureTagId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetFeatureTag>>> = ({ signal }) =>
    adminGetFeatureTag(featureTagId, signal);

  return { queryKey, queryFn, enabled: !!featureTagId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetFeatureTag>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetFeatureTagQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetFeatureTag>>
>;
export type AdminGetFeatureTagQueryError = ErrorType<ProblemDetails>;

export function useAdminGetFeatureTag<
  TData = Awaited<ReturnType<typeof adminGetFeatureTag>>,
  TError = ErrorType<ProblemDetails>,
>(
  featureTagId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTag>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetFeatureTag>>,
          TError,
          Awaited<ReturnType<typeof adminGetFeatureTag>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetFeatureTag<
  TData = Awaited<ReturnType<typeof adminGetFeatureTag>>,
  TError = ErrorType<ProblemDetails>,
>(
  featureTagId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTag>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetFeatureTag>>,
          TError,
          Awaited<ReturnType<typeof adminGetFeatureTag>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetFeatureTag<
  TData = Awaited<ReturnType<typeof adminGetFeatureTag>>,
  TError = ErrorType<ProblemDetails>,
>(
  featureTagId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTag>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get feature tag
 */

export function useAdminGetFeatureTag<
  TData = Awaited<ReturnType<typeof adminGetFeatureTag>>,
  TError = ErrorType<ProblemDetails>,
>(
  featureTagId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetFeatureTag>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetFeatureTagQueryOptions(featureTagId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Applies a partial update to a feature catalog tag's product and/or description. The feature code is immutable. Requires Admin role.
 * @summary Update feature tag
 */
export const adminUpdateFeatureTag = (
  featureTagId: string,
  updateFeatureTagRequest: UpdateFeatureTagRequest
) => {
  return instance<FeatureTagResponse>({
    url: `/v1/admin/feature-tags/${featureTagId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateFeatureTagRequest,
  });
};

export const getAdminUpdateFeatureTagMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateFeatureTag>>,
    TError,
    { featureTagId: string; data: UpdateFeatureTagRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateFeatureTag>>,
  TError,
  { featureTagId: string; data: UpdateFeatureTagRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateFeatureTag'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateFeatureTag>>,
    { featureTagId: string; data: UpdateFeatureTagRequest }
  > = (props) => {
    const { featureTagId, data } = props ?? {};

    return adminUpdateFeatureTag(featureTagId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateFeatureTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateFeatureTag>>
>;
export type AdminUpdateFeatureTagMutationBody = UpdateFeatureTagRequest;
export type AdminUpdateFeatureTagMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update feature tag
 */
export const useAdminUpdateFeatureTag = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateFeatureTag>>,
      TError,
      { featureTagId: string; data: UpdateFeatureTagRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateFeatureTag>>,
  TError,
  { featureTagId: string; data: UpdateFeatureTagRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateFeatureTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a feature catalog tag. Rejected with a conflict when any organization still has the tag's feature code configured. Requires Admin role.
 * @summary Delete feature tag
 */
export const adminDeleteFeatureTag = (featureTagId: string) => {
  return instance<void>({ url: `/v1/admin/feature-tags/${featureTagId}`, method: 'DELETE' });
};

export const getAdminDeleteFeatureTagMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteFeatureTag>>,
    TError,
    { featureTagId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteFeatureTag>>,
  TError,
  { featureTagId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteFeatureTag'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteFeatureTag>>,
    { featureTagId: string }
  > = (props) => {
    const { featureTagId } = props ?? {};

    return adminDeleteFeatureTag(featureTagId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteFeatureTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteFeatureTag>>
>;

export type AdminDeleteFeatureTagMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete feature tag
 */
export const useAdminDeleteFeatureTag = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteFeatureTag>>,
      TError,
      { featureTagId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteFeatureTag>>,
  TError,
  { featureTagId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteFeatureTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates an organization invitation by email and role on behalf of a trusted upstream service. Mirrors the user-authenticated invitation flow including the Microsoft invitation email but does not require an authenticated Administrator. Requires Admin role.
 * @summary Create invitation (admin)
 */
export const adminCreateInvitation = (
  orgId: string,
  createInvitationAdminRequest: CreateInvitationAdminRequest,
  signal?: AbortSignal
) => {
  return instance<AdminInvitationResponse>({
    url: `/v1/admin/organizations/${orgId}/invitations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInvitationAdminRequest,
    signal,
  });
};

export const getAdminCreateInvitationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateInvitation>>,
    TError,
    { orgId: string; data: CreateInvitationAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateInvitation>>,
  TError,
  { orgId: string; data: CreateInvitationAdminRequest },
  TContext
> => {
  const mutationKey = ['adminCreateInvitation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateInvitation>>,
    { orgId: string; data: CreateInvitationAdminRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminCreateInvitation(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateInvitation>>
>;
export type AdminCreateInvitationMutationBody = CreateInvitationAdminRequest;
export type AdminCreateInvitationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create invitation (admin)
 */
export const useAdminCreateInvitation = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateInvitation>>,
      TError,
      { orgId: string; data: CreateInvitationAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateInvitation>>,
  TError,
  { orgId: string; data: CreateInvitationAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateInvitationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Removes a UserRole assignment. Used to cancel a pending invitation before acceptance (typically because the contact email was wrong). Any orphaned User record with no OID and no other role assignments is left in place. Requires Admin role.
 * @summary Cancel role (admin)
 */
export const adminCancelRole = (orgId: string, roleId: string) => {
  return instance<void>({
    url: `/v1/admin/organizations/${orgId}/roles/${roleId}`,
    method: 'DELETE',
  });
};

export const getAdminCancelRoleMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCancelRole>>,
    TError,
    { orgId: string; roleId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCancelRole>>,
  TError,
  { orgId: string; roleId: string },
  TContext
> => {
  const mutationKey = ['adminCancelRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCancelRole>>,
    { orgId: string; roleId: string }
  > = (props) => {
    const { orgId, roleId } = props ?? {};

    return adminCancelRole(orgId, roleId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCancelRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCancelRole>>
>;

export type AdminCancelRoleMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Cancel role (admin)
 */
export const useAdminCancelRole = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCancelRole>>,
      TError,
      { orgId: string; roleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCancelRole>>,
  TError,
  { orgId: string; roleId: string },
  TContext
> => {
  const mutationOptions = getAdminCancelRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all legal documents grouped by type. Requires Admin role.
 * @summary List legal documents
 */
export const adminGetLegalDocuments = (signal?: AbortSignal) => {
  return instance<LegalDocumentsListResponse>({
    url: `/v1/admin/legal-documents`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetLegalDocumentsQueryKey = () => {
  return [`/v1/admin/legal-documents`] as const;
};

export const getAdminGetLegalDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLegalDocuments>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocuments>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetLegalDocumentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLegalDocuments>>> = ({ signal }) =>
    adminGetLegalDocuments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLegalDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetLegalDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLegalDocuments>>
>;
export type AdminGetLegalDocumentsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetLegalDocuments<
  TData = Awaited<ReturnType<typeof adminGetLegalDocuments>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocuments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocuments>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocuments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocuments<
  TData = Awaited<ReturnType<typeof adminGetLegalDocuments>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocuments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocuments>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocuments>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocuments<
  TData = Awaited<ReturnType<typeof adminGetLegalDocuments>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocuments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List legal documents
 */

export function useAdminGetLegalDocuments<
  TData = Awaited<ReturnType<typeof adminGetLegalDocuments>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocuments>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetLegalDocumentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets all versions for a document type. Requires Admin role.
 * @summary List versions
 */
export const adminGetLegalDocumentVersions = (type: string, signal?: AbortSignal) => {
  return instance<LegalDocumentVersionListResponse>({
    url: `/v1/admin/legal-documents/${type}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetLegalDocumentVersionsQueryKey = (type?: string) => {
  return [`/v1/admin/legal-documents/${type}`] as const;
};

export const getAdminGetLegalDocumentVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetLegalDocumentVersionsQueryKey(type);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>> = ({
    signal,
  }) => adminGetLegalDocumentVersions(type, signal);

  return { queryKey, queryFn, enabled: !!type, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetLegalDocumentVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>
>;
export type AdminGetLegalDocumentVersionsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetLegalDocumentVersions<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocumentVersions<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocumentVersions<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List versions
 */

export function useAdminGetLegalDocumentVersions<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetLegalDocumentVersionsQueryOptions(type, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a specific version with its links. Requires Admin role.
 * @summary Get version
 */
export const adminGetLegalDocumentVersion = (
  type: string,
  version: string,
  signal?: AbortSignal
) => {
  return instance<LegalDocumentVersionResponse>({
    url: `/v1/admin/legal-documents/${type}/versions/${version}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetLegalDocumentVersionQueryKey = (type?: string, version?: string) => {
  return [`/v1/admin/legal-documents/${type}/versions/${version}`] as const;
};

export const getAdminGetLegalDocumentVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetLegalDocumentVersionQueryKey(type, version);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>> = ({
    signal,
  }) => adminGetLegalDocumentVersion(type, version, signal);

  return { queryKey, queryFn, enabled: !!(type && version), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetLegalDocumentVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>
>;
export type AdminGetLegalDocumentVersionQueryError = ErrorType<ProblemDetails>;

export function useAdminGetLegalDocumentVersion<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocumentVersion<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
          TError,
          Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetLegalDocumentVersion<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get version
 */

export function useAdminGetLegalDocumentVersion<
  TData = Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>,
  TError = ErrorType<ProblemDetails>,
>(
  type: string,
  version: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetLegalDocumentVersion>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetLegalDocumentVersionQueryOptions(type, version, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new version for a document type. English link required. Requires Admin role.
 * @summary Create version
 */
export const adminCreateLegalDocumentVersion = (
  type: string,
  createLegalDocumentVersionRequest: CreateLegalDocumentVersionRequest,
  signal?: AbortSignal
) => {
  return instance<LegalDocumentVersionResponse>({
    url: `/v1/admin/legal-documents/${type}/versions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createLegalDocumentVersionRequest,
    signal,
  });
};

export const getAdminCreateLegalDocumentVersionMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
    TError,
    { type: string; data: CreateLegalDocumentVersionRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
  TError,
  { type: string; data: CreateLegalDocumentVersionRequest },
  TContext
> => {
  const mutationKey = ['adminCreateLegalDocumentVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
    { type: string; data: CreateLegalDocumentVersionRequest }
  > = (props) => {
    const { type, data } = props ?? {};

    return adminCreateLegalDocumentVersion(type, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateLegalDocumentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>
>;
export type AdminCreateLegalDocumentVersionMutationBody = CreateLegalDocumentVersionRequest;
export type AdminCreateLegalDocumentVersionMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create version
 */
export const useAdminCreateLegalDocumentVersion = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
      TError,
      { type: string; data: CreateLegalDocumentVersionRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateLegalDocumentVersion>>,
  TError,
  { type: string; data: CreateLegalDocumentVersionRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateLegalDocumentVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates or updates a link for a specific version and language. Requires Admin role.
 * @summary Upsert link
 */
export const adminUpsertLegalDocumentLink = (
  type: string,
  version: string,
  upsertLegalDocumentLinkRequest: UpsertLegalDocumentLinkRequest
) => {
  return instance<LegalDocumentLinkResponse>({
    url: `/v1/admin/legal-documents/${type}/versions/${version}/links`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upsertLegalDocumentLinkRequest,
  });
};

export const getAdminUpsertLegalDocumentLinkMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>,
    TError,
    { type: string; version: string; data: UpsertLegalDocumentLinkRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>,
  TError,
  { type: string; version: string; data: UpsertLegalDocumentLinkRequest },
  TContext
> => {
  const mutationKey = ['adminUpsertLegalDocumentLink'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>,
    { type: string; version: string; data: UpsertLegalDocumentLinkRequest }
  > = (props) => {
    const { type, version, data } = props ?? {};

    return adminUpsertLegalDocumentLink(type, version, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpsertLegalDocumentLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>
>;
export type AdminUpsertLegalDocumentLinkMutationBody = UpsertLegalDocumentLinkRequest;
export type AdminUpsertLegalDocumentLinkMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Upsert link
 */
export const useAdminUpsertLegalDocumentLink = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>,
      TError,
      { type: string; version: string; data: UpsertLegalDocumentLinkRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpsertLegalDocumentLink>>,
  TError,
  { type: string; version: string; data: UpsertLegalDocumentLinkRequest },
  TContext
> => {
  const mutationOptions = getAdminUpsertLegalDocumentLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sets a version as active. Users will need to accept this version. Requires Admin role.
 * @summary Activate version
 */
export const adminActivateLegalDocumentVersion = (
  type: string,
  version: string,
  signal?: AbortSignal
) => {
  return instance<LegalDocumentVersionResponse>({
    url: `/v1/admin/legal-documents/${type}/versions/${version}/activate`,
    method: 'POST',
    signal,
  });
};

export const getAdminActivateLegalDocumentVersionMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
    TError,
    { type: string; version: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
  TError,
  { type: string; version: string },
  TContext
> => {
  const mutationKey = ['adminActivateLegalDocumentVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
    { type: string; version: string }
  > = (props) => {
    const { type, version } = props ?? {};

    return adminActivateLegalDocumentVersion(type, version);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminActivateLegalDocumentVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>
>;

export type AdminActivateLegalDocumentVersionMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Activate version
 */
export const useAdminActivateLegalDocumentVersion = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
      TError,
      { type: string; version: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminActivateLegalDocumentVersion>>,
  TError,
  { type: string; version: string },
  TContext
> => {
  const mutationOptions = getAdminActivateLegalDocumentVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a manual administrative entitlement on an existing organization product registration with caller-supplied rule, StartUtc, and EndUtc. Source is set to ManualAdminGrant; TrialId, StripeSubscriptionId, and IsDefault are unset. Requires Admin role.
 * @summary Grant manual entitlement (admin)
 */
export const adminGrantEntitlement = (
  registrationId: string,
  grantEntitlementAdminRequest: GrantEntitlementAdminRequest,
  signal?: AbortSignal
) => {
  return instance<AdminEntitlementResponse>({
    url: `/v1/admin/product-registrations/${registrationId}/entitlements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: grantEntitlementAdminRequest,
    signal,
  });
};

export const getAdminGrantEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGrantEntitlement>>,
    TError,
    { registrationId: string; data: GrantEntitlementAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGrantEntitlement>>,
  TError,
  { registrationId: string; data: GrantEntitlementAdminRequest },
  TContext
> => {
  const mutationKey = ['adminGrantEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGrantEntitlement>>,
    { registrationId: string; data: GrantEntitlementAdminRequest }
  > = (props) => {
    const { registrationId, data } = props ?? {};

    return adminGrantEntitlement(registrationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGrantEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGrantEntitlement>>
>;
export type AdminGrantEntitlementMutationBody = GrantEntitlementAdminRequest;
export type AdminGrantEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Grant manual entitlement (admin)
 */
export const useAdminGrantEntitlement = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminGrantEntitlement>>,
      TError,
      { registrationId: string; data: GrantEntitlementAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminGrantEntitlement>>,
  TError,
  { registrationId: string; data: GrantEntitlementAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminGrantEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Applies a partial update to a manual-grant entitlement. Each field on the request is optional; null leaves it unchanged. Refuses to mutate entitlements whose source is not ManualAdminGrant. Requires Admin role.
 * @summary Update manual entitlement (admin)
 */
export const adminUpdateEntitlement = (
  entitlementId: string,
  updateEntitlementAdminRequest: UpdateEntitlementAdminRequest
) => {
  return instance<AdminEntitlementResponse>({
    url: `/v1/admin/entitlements/${entitlementId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateEntitlementAdminRequest,
  });
};

export const getAdminUpdateEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateEntitlement>>,
    TError,
    { entitlementId: string; data: UpdateEntitlementAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateEntitlement>>,
  TError,
  { entitlementId: string; data: UpdateEntitlementAdminRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateEntitlement>>,
    { entitlementId: string; data: UpdateEntitlementAdminRequest }
  > = (props) => {
    const { entitlementId, data } = props ?? {};

    return adminUpdateEntitlement(entitlementId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateEntitlement>>
>;
export type AdminUpdateEntitlementMutationBody = UpdateEntitlementAdminRequest;
export type AdminUpdateEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update manual entitlement (admin)
 */
export const useAdminUpdateEntitlement = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateEntitlement>>,
      TError,
      { entitlementId: string; data: UpdateEntitlementAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateEntitlement>>,
  TError,
  { entitlementId: string; data: UpdateEntitlementAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Disables a manual-grant entitlement by setting Enabled = false. Idempotent. Requires Admin role.
 * @summary Disable manual entitlement (admin)
 */
export const adminDisableEntitlement = (entitlementId: string) => {
  return instance<AdminEntitlementResponse>({
    url: `/v1/admin/entitlements/${entitlementId}`,
    method: 'DELETE',
  });
};

export const getAdminDisableEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDisableEntitlement>>,
    TError,
    { entitlementId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDisableEntitlement>>,
  TError,
  { entitlementId: string },
  TContext
> => {
  const mutationKey = ['adminDisableEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDisableEntitlement>>,
    { entitlementId: string }
  > = (props) => {
    const { entitlementId } = props ?? {};

    return adminDisableEntitlement(entitlementId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDisableEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDisableEntitlement>>
>;

export type AdminDisableEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Disable manual entitlement (admin)
 */
export const useAdminDisableEntitlement = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDisableEntitlement>>,
      TError,
      { entitlementId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDisableEntitlement>>,
  TError,
  { entitlementId: string },
  TContext
> => {
  const mutationOptions = getAdminDisableEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sends a test notification to the authenticated admin user. The notification is queued and processed through the normal notification pipeline.
 * @summary Send test notification
 */
export const adminSendTestNotification = (
  sendTestNotificationRequest: SendTestNotificationRequest,
  signal?: AbortSignal
) => {
  return instance<void>({
    url: `/v1/admin/notifications/test`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sendTestNotificationRequest,
    signal,
  });
};

export const getAdminSendTestNotificationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSendTestNotification>>,
    TError,
    { data: SendTestNotificationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSendTestNotification>>,
  TError,
  { data: SendTestNotificationRequest },
  TContext
> => {
  const mutationKey = ['adminSendTestNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSendTestNotification>>,
    { data: SendTestNotificationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminSendTestNotification(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSendTestNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSendTestNotification>>
>;
export type AdminSendTestNotificationMutationBody = SendTestNotificationRequest;
export type AdminSendTestNotificationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Send test notification
 */
export const useAdminSendTestNotification = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSendTestNotification>>,
      TError,
      { data: SendTestNotificationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSendTestNotification>>,
  TError,
  { data: SendTestNotificationRequest },
  TContext
> => {
  const mutationOptions = getAdminSendTestNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new notification template. Requires Admin role.
 * @summary Create notification template
 */
export const adminCreateNotificationTemplate = (
  createNotificationTemplateRequest: CreateNotificationTemplateRequest,
  signal?: AbortSignal
) => {
  return instance<NotificationTemplateResponse>({
    url: `/v1/admin/notifications/templates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createNotificationTemplateRequest,
    signal,
  });
};

export const getAdminCreateNotificationTemplateMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateNotificationTemplate>>,
    TError,
    { data: CreateNotificationTemplateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateNotificationTemplate>>,
  TError,
  { data: CreateNotificationTemplateRequest },
  TContext
> => {
  const mutationKey = ['adminCreateNotificationTemplate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateNotificationTemplate>>,
    { data: CreateNotificationTemplateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateNotificationTemplate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateNotificationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateNotificationTemplate>>
>;
export type AdminCreateNotificationTemplateMutationBody = CreateNotificationTemplateRequest;
export type AdminCreateNotificationTemplateMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create notification template
 */
export const useAdminCreateNotificationTemplate = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateNotificationTemplate>>,
      TError,
      { data: CreateNotificationTemplateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateNotificationTemplate>>,
  TError,
  { data: CreateNotificationTemplateRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateNotificationTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all notification templates. Requires Admin role.
 * @summary List notification templates
 */
export const adminGetNotificationTemplates = (signal?: AbortSignal) => {
  return instance<NotificationTemplateListResponse>({
    url: `/v1/admin/notifications/templates`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetNotificationTemplatesQueryKey = () => {
  return [`/v1/admin/notifications/templates`] as const;
};

export const getAdminGetNotificationTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplates>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetNotificationTemplatesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetNotificationTemplates>>> = ({
    signal,
  }) => adminGetNotificationTemplates(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetNotificationTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetNotificationTemplates>>
>;
export type AdminGetNotificationTemplatesQueryError = ErrorType<ProblemDetails>;

export function useAdminGetNotificationTemplates<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
          TError,
          Awaited<ReturnType<typeof adminGetNotificationTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetNotificationTemplates<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
          TError,
          Awaited<ReturnType<typeof adminGetNotificationTemplates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetNotificationTemplates<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List notification templates
 */

export function useAdminGetNotificationTemplates<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplates>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetNotificationTemplatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a notification template by ID. Requires Admin role.
 * @summary Get notification template
 */
export const adminGetNotificationTemplate = (templateId: string, signal?: AbortSignal) => {
  return instance<NotificationTemplateResponse>({
    url: `/v1/admin/notifications/templates/${templateId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetNotificationTemplateQueryKey = (templateId?: string) => {
  return [`/v1/admin/notifications/templates/${templateId}`] as const;
};

export const getAdminGetNotificationTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
  TError = ErrorType<ProblemDetails>,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplate>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetNotificationTemplateQueryKey(templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetNotificationTemplate>>> = ({
    signal,
  }) => adminGetNotificationTemplate(templateId, signal);

  return { queryKey, queryFn, enabled: !!templateId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetNotificationTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetNotificationTemplate>>
>;
export type AdminGetNotificationTemplateQueryError = ErrorType<ProblemDetails>;

export function useAdminGetNotificationTemplate<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
  TError = ErrorType<ProblemDetails>,
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
          TError,
          Awaited<ReturnType<typeof adminGetNotificationTemplate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetNotificationTemplate<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
  TError = ErrorType<ProblemDetails>,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
          TError,
          Awaited<ReturnType<typeof adminGetNotificationTemplate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetNotificationTemplate<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
  TError = ErrorType<ProblemDetails>,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get notification template
 */

export function useAdminGetNotificationTemplate<
  TData = Awaited<ReturnType<typeof adminGetNotificationTemplate>>,
  TError = ErrorType<ProblemDetails>,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetNotificationTemplate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetNotificationTemplateQueryOptions(templateId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a notification template. Requires Admin role.
 * @summary Update notification template
 */
export const adminUpdateNotificationTemplate = (
  templateId: string,
  updateNotificationTemplateRequest: UpdateNotificationTemplateRequest
) => {
  return instance<NotificationTemplateResponse>({
    url: `/v1/admin/notifications/templates/${templateId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateNotificationTemplateRequest,
  });
};

export const getAdminUpdateNotificationTemplateMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>,
    TError,
    { templateId: string; data: UpdateNotificationTemplateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>,
  TError,
  { templateId: string; data: UpdateNotificationTemplateRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateNotificationTemplate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>,
    { templateId: string; data: UpdateNotificationTemplateRequest }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return adminUpdateNotificationTemplate(templateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateNotificationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>
>;
export type AdminUpdateNotificationTemplateMutationBody = UpdateNotificationTemplateRequest;
export type AdminUpdateNotificationTemplateMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update notification template
 */
export const useAdminUpdateNotificationTemplate = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>,
      TError,
      { templateId: string; data: UpdateNotificationTemplateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateNotificationTemplate>>,
  TError,
  { templateId: string; data: UpdateNotificationTemplateRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateNotificationTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a notification template and all its content. Requires Admin role.
 * @summary Delete notification template
 */
export const adminDeleteNotificationTemplate = (templateId: string) => {
  return instance<void>({
    url: `/v1/admin/notifications/templates/${templateId}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteNotificationTemplateMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>,
    TError,
    { templateId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteNotificationTemplate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>,
    { templateId: string }
  > = (props) => {
    const { templateId } = props ?? {};

    return adminDeleteNotificationTemplate(templateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteNotificationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>
>;

export type AdminDeleteNotificationTemplateMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete notification template
 */
export const useAdminDeleteNotificationTemplate = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>,
      TError,
      { templateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteNotificationTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates or updates content for a notification template in a specific language. Requires Admin role.
 * @summary Upsert template content
 */
export const adminUpsertNotificationTemplateContent = (
  templateId: string,
  upsertNotificationTemplateContentRequest: UpsertNotificationTemplateContentRequest
) => {
  return instance<NotificationTemplateResponse>({
    url: `/v1/admin/notifications/templates/${templateId}/content`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upsertNotificationTemplateContentRequest,
  });
};

export const getAdminUpsertNotificationTemplateContentMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>,
    TError,
    { templateId: string; data: UpsertNotificationTemplateContentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>,
  TError,
  { templateId: string; data: UpsertNotificationTemplateContentRequest },
  TContext
> => {
  const mutationKey = ['adminUpsertNotificationTemplateContent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>,
    { templateId: string; data: UpsertNotificationTemplateContentRequest }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return adminUpsertNotificationTemplateContent(templateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpsertNotificationTemplateContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>
>;
export type AdminUpsertNotificationTemplateContentMutationBody =
  UpsertNotificationTemplateContentRequest;
export type AdminUpsertNotificationTemplateContentMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Upsert template content
 */
export const useAdminUpsertNotificationTemplateContent = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>,
      TError,
      { templateId: string; data: UpsertNotificationTemplateContentRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpsertNotificationTemplateContent>>,
  TError,
  { templateId: string; data: UpsertNotificationTemplateContentRequest },
  TContext
> => {
  const mutationOptions = getAdminUpsertNotificationTemplateContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes content for a notification template in a specific language. Requires Admin role.
 * @summary Delete template content
 */
export const adminDeleteNotificationTemplateContent = (
  templateId: string,
  language: 'en' | 'fr' | 'de' | 'es' = 'en'
) => {
  return instance<void>({
    url: `/v1/admin/notifications/templates/${templateId}/content/${language}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteNotificationTemplateContentMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>,
    TError,
    { templateId: string; language?: 'en' | 'fr' | 'de' | 'es' },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>,
  TError,
  { templateId: string; language?: 'en' | 'fr' | 'de' | 'es' },
  TContext
> => {
  const mutationKey = ['adminDeleteNotificationTemplateContent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>,
    { templateId: string; language?: 'en' | 'fr' | 'de' | 'es' }
  > = (props) => {
    const { templateId, language } = props ?? {};

    return adminDeleteNotificationTemplateContent(templateId, language);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteNotificationTemplateContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>
>;

export type AdminDeleteNotificationTemplateContentMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete template content
 */
export const useAdminDeleteNotificationTemplateContent = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>,
      TError,
      { templateId: string; language?: 'en' | 'fr' | 'de' | 'es' },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteNotificationTemplateContent>>,
  TError,
  { templateId: string; language?: 'en' | 'fr' | 'de' | 'es' },
  TContext
> => {
  const mutationOptions = getAdminDeleteNotificationTemplateContentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new organization on behalf of a trusted upstream service. Requires Admin role. Does not assign any user as Administrator. Rejects flag combinations that break a pricing-tier invariant: IsNonProfit and IsPartner are mutually exclusive, and a partner org (IsPartner = true) cannot also carry a SourcePartnerId.
 * @summary Create organization (admin)
 */
export const adminCreateOrganization = (
  createOrganizationAdminRequest: CreateOrganizationAdminRequest,
  signal?: AbortSignal
) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOrganizationAdminRequest,
    signal,
  });
};

export const getAdminCreateOrganizationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateOrganization>>,
    TError,
    { data: CreateOrganizationAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateOrganization>>,
  TError,
  { data: CreateOrganizationAdminRequest },
  TContext
> => {
  const mutationKey = ['adminCreateOrganization'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateOrganization>>,
    { data: CreateOrganizationAdminRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateOrganization(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateOrganization>>
>;
export type AdminCreateOrganizationMutationBody = CreateOrganizationAdminRequest;
export type AdminCreateOrganizationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create organization (admin)
 */
export const useAdminCreateOrganization = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateOrganization>>,
      TError,
      { data: CreateOrganizationAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateOrganization>>,
  TError,
  { data: CreateOrganizationAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cursor-paginated change feed of organizations ordered by (UpdatedUtc, Id) for sync consumers. Requires Admin role.
 * @summary List organizations (admin change feed)
 */
export const adminListOrganizations = (
  params?: AdminListOrganizationsParams,
  signal?: AbortSignal
) => {
  return instance<AdminOrganizationsPageResponse>({
    url: `/v1/admin/organizations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListOrganizationsQueryKey = (params?: AdminListOrganizationsParams) => {
  return [`/v1/admin/organizations`, ...(params ? [params] : [])] as const;
};

export const getAdminListOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListOrganizationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListOrganizations>>> = ({ signal }) =>
    adminListOrganizations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListOrganizations>>
>;
export type AdminListOrganizationsQueryError = ErrorType<ProblemDetails>;

export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListOrganizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List organizations (admin change feed)
 */

export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an organization including partner-program fields. Requires Admin role.
 * @summary Get organization (admin)
 */
export const adminGetOrganization = (orgId: string, signal?: AbortSignal) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations/${orgId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetOrganizationQueryKey = (orgId?: string) => {
  return [`/v1/admin/organizations/${orgId}`] as const;
};

export const getAdminGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetOrganization>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetOrganizationQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetOrganization>>> = ({ signal }) =>
    adminGetOrganization(orgId, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetOrganization>>
>;
export type AdminGetOrganizationQueryError = ErrorType<ProblemDetails>;

export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetOrganization>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminGetOrganization>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetOrganization>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminGetOrganization>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetOrganization>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get organization (admin)
 */

export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = ErrorType<ProblemDetails>,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetOrganization>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetOrganizationQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Applies a partial update to an organization's name and partner-program fields (Name, IsPartner, IsNonProfit, PartnerIdentifier). Omitted or null fields are left unchanged; an empty PartnerIdentifier clears it. Other fields are not writable through this endpoint. Requires Admin role. Rejects a blank Name, a PartnerIdentifier longer than 256 characters or already used by another organization, and an update where the resulting row would break a pricing-tier invariant: IsNonProfit and IsPartner are mutually exclusive, and setting IsPartner = true on an org that already has a SourcePartnerId is not allowed.
 * @summary Update organization (admin)
 */
export const adminUpdateOrganization = (
  orgId: string,
  updateOrganizationAdminRequest: UpdateOrganizationAdminRequest
) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations/${orgId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationAdminRequest,
  });
};

export const getAdminUpdateOrganizationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateOrganization>>,
    TError,
    { orgId: string; data: UpdateOrganizationAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateOrganization>>,
  TError,
  { orgId: string; data: UpdateOrganizationAdminRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateOrganization'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateOrganization>>,
    { orgId: string; data: UpdateOrganizationAdminRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminUpdateOrganization(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateOrganization>>
>;
export type AdminUpdateOrganizationMutationBody = UpdateOrganizationAdminRequest;
export type AdminUpdateOrganizationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update organization (admin)
 */
export const useAdminUpdateOrganization = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateOrganization>>,
      TError,
      { orgId: string; data: UpdateOrganizationAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateOrganization>>,
  TError,
  { orgId: string; data: UpdateOrganizationAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateOrganizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Replaces an organization's configured product features with the supplied map (feature code -> free-text value). Every key must reference a feature code defined in the feature catalog; unknown codes are rejected. An empty map clears all features. Values are free text and are not interpreted by the Auth Service. Requires Admin role.
 * @summary Set organization features (admin)
 */
export const adminUpdateOrganizationFeatures = (
  orgId: string,
  updateOrganizationFeaturesAdminRequest: UpdateOrganizationFeaturesAdminRequest
) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations/${orgId}/features`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationFeaturesAdminRequest,
  });
};

export const getAdminUpdateOrganizationFeaturesMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>,
    TError,
    { orgId: string; data: UpdateOrganizationFeaturesAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>,
  TError,
  { orgId: string; data: UpdateOrganizationFeaturesAdminRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateOrganizationFeatures'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>,
    { orgId: string; data: UpdateOrganizationFeaturesAdminRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminUpdateOrganizationFeatures(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateOrganizationFeaturesMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>
>;
export type AdminUpdateOrganizationFeaturesMutationBody = UpdateOrganizationFeaturesAdminRequest;
export type AdminUpdateOrganizationFeaturesMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Set organization features (admin)
 */
export const useAdminUpdateOrganizationFeatures = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>,
      TError,
      { orgId: string; data: UpdateOrganizationFeaturesAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateOrganizationFeatures>>,
  TError,
  { orgId: string; data: UpdateOrganizationFeaturesAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateOrganizationFeaturesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sets or clears the CurrentPartner association on an organization. The supplied value must reference an existing Organization where IsPartner = true (or be null to clear). Optional 'reason' is recorded in the CurrentPartner history row. Does not touch SourcePartnerId. Requires Admin role.
 * @summary Set CurrentPartner (admin)
 */
export const adminUpdateOrganizationCurrentPartner = (
  orgId: string,
  updateOrganizationCurrentPartnerAdminRequest: UpdateOrganizationCurrentPartnerAdminRequest
) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations/${orgId}/current-partner`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationCurrentPartnerAdminRequest,
  });
};

export const getAdminUpdateOrganizationCurrentPartnerMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>,
    TError,
    { orgId: string; data: UpdateOrganizationCurrentPartnerAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>,
  TError,
  { orgId: string; data: UpdateOrganizationCurrentPartnerAdminRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateOrganizationCurrentPartner'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>,
    { orgId: string; data: UpdateOrganizationCurrentPartnerAdminRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminUpdateOrganizationCurrentPartner(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateOrganizationCurrentPartnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>
>;
export type AdminUpdateOrganizationCurrentPartnerMutationBody =
  UpdateOrganizationCurrentPartnerAdminRequest;
export type AdminUpdateOrganizationCurrentPartnerMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Set CurrentPartner (admin)
 */
export const useAdminUpdateOrganizationCurrentPartner = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>,
      TError,
      { orgId: string; data: UpdateOrganizationCurrentPartnerAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateOrganizationCurrentPartner>>,
  TError,
  { orgId: string; data: UpdateOrganizationCurrentPartnerAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateOrganizationCurrentPartnerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sets or clears the SourcePartner association on an organization. The supplied value must reference an existing Organization where IsPartner = true (or be null to clear). The target org itself must not be a partner (IsPartner = true), since a partner cannot have a source partner. Optional 'reason' is recorded in the audit log. Does not touch CurrentPartnerId. Requires Admin role.
 * @summary Set SourcePartner (admin)
 */
export const adminUpdateOrganizationSourcePartner = (
  orgId: string,
  updateOrganizationSourcePartnerAdminRequest: UpdateOrganizationSourcePartnerAdminRequest
) => {
  return instance<AdminOrganizationResponse>({
    url: `/v1/admin/organizations/${orgId}/source-partner`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateOrganizationSourcePartnerAdminRequest,
  });
};

export const getAdminUpdateOrganizationSourcePartnerMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>,
    TError,
    { orgId: string; data: UpdateOrganizationSourcePartnerAdminRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>,
  TError,
  { orgId: string; data: UpdateOrganizationSourcePartnerAdminRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateOrganizationSourcePartner'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>,
    { orgId: string; data: UpdateOrganizationSourcePartnerAdminRequest }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminUpdateOrganizationSourcePartner(orgId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateOrganizationSourcePartnerMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>
>;
export type AdminUpdateOrganizationSourcePartnerMutationBody =
  UpdateOrganizationSourcePartnerAdminRequest;
export type AdminUpdateOrganizationSourcePartnerMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Set SourcePartner (admin)
 */
export const useAdminUpdateOrganizationSourcePartner = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>,
      TError,
      { orgId: string; data: UpdateOrganizationSourcePartnerAdminRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateOrganizationSourcePartner>>,
  TError,
  { orgId: string; data: UpdateOrganizationSourcePartnerAdminRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateOrganizationSourcePartnerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cursor-paginated change feed of organization_current_partner_history rows ordered by (ChangedAtUtc, Id) for sync consumers. Requires Admin role.
 * @summary List CurrentPartner history (admin change feed)
 */
export const adminListOrganizationCurrentPartnerHistory = (
  params?: AdminListOrganizationCurrentPartnerHistoryParams,
  signal?: AbortSignal
) => {
  return instance<AdminOrganizationCurrentPartnerHistoryPageResponse>({
    url: `/v1/admin/organization-current-partner-history`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListOrganizationCurrentPartnerHistoryQueryKey = (
  params?: AdminListOrganizationCurrentPartnerHistoryParams
) => {
  return [`/v1/admin/organization-current-partner-history`, ...(params ? [params] : [])] as const;
};

export const getAdminListOrganizationCurrentPartnerHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationCurrentPartnerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListOrganizationCurrentPartnerHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>
  > = ({ signal }) => adminListOrganizationCurrentPartnerHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListOrganizationCurrentPartnerHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>
>;
export type AdminListOrganizationCurrentPartnerHistoryQueryError = ErrorType<ProblemDetails>;

export function useAdminListOrganizationCurrentPartnerHistory<
  TData = Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListOrganizationCurrentPartnerHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListOrganizationCurrentPartnerHistory<
  TData = Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationCurrentPartnerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListOrganizationCurrentPartnerHistory<
  TData = Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationCurrentPartnerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List CurrentPartner history (admin change feed)
 */

export function useAdminListOrganizationCurrentPartnerHistory<
  TData = Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListOrganizationCurrentPartnerHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizationCurrentPartnerHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListOrganizationCurrentPartnerHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cursor-paginated change feed of all product entitlements ordered by (UpdatedUtc, Id) for sync consumers. Requires Admin role.
 * @summary List product entitlements (admin change feed)
 */
export const adminListProductEntitlements = (
  params?: AdminListProductEntitlementsParams,
  signal?: AbortSignal
) => {
  return instance<AdminEntitlementsPageResponse>({
    url: `/v1/admin/product-entitlements`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListProductEntitlementsQueryKey = (
  params?: AdminListProductEntitlementsParams
) => {
  return [`/v1/admin/product-entitlements`, ...(params ? [params] : [])] as const;
};

export const getAdminListProductEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListProductEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductEntitlementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductEntitlements>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListProductEntitlementsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListProductEntitlements>>> = ({
    signal,
  }) => adminListProductEntitlements(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListProductEntitlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListProductEntitlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListProductEntitlements>>
>;
export type AdminListProductEntitlementsQueryError = ErrorType<ProblemDetails>;

export function useAdminListProductEntitlements<
  TData = Awaited<ReturnType<typeof adminListProductEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListProductEntitlementsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductEntitlements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminListProductEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductEntitlements<
  TData = Awaited<ReturnType<typeof adminListProductEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductEntitlementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductEntitlements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminListProductEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductEntitlements<
  TData = Awaited<ReturnType<typeof adminListProductEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductEntitlementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List product entitlements (admin change feed)
 */

export function useAdminListProductEntitlements<
  TData = Awaited<ReturnType<typeof adminListProductEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductEntitlementsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListProductEntitlementsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new OrgProductRegistration for the given organization and product on behalf of a trusted upstream service. Requires Admin role. Returns Conflict if a registration for this (orgId, productId) already exists. Provisions the product's default entitlement on success, mirroring the user-authenticated registration flow.
 * @summary Register product for organization (admin)
 */
export const adminCreateOrganizationProductRegistration = (
  orgId: string,
  productId: string,
  signal?: AbortSignal
) => {
  return instance<ProductRegistrationResponse>({
    url: `/v1/admin/organizations/${orgId}/products/${productId}/register`,
    method: 'POST',
    signal,
  });
};

export const getAdminCreateOrganizationProductRegistrationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>,
    TError,
    { orgId: string; productId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>,
  TError,
  { orgId: string; productId: string },
  TContext
> => {
  const mutationKey = ['adminCreateOrganizationProductRegistration'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>,
    { orgId: string; productId: string }
  > = (props) => {
    const { orgId, productId } = props ?? {};

    return adminCreateOrganizationProductRegistration(orgId, productId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateOrganizationProductRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>
>;

export type AdminCreateOrganizationProductRegistrationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Register product for organization (admin)
 */
export const useAdminCreateOrganizationProductRegistration = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>,
      TError,
      { orgId: string; productId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateOrganizationProductRegistration>>,
  TError,
  { orgId: string; productId: string },
  TContext
> => {
  const mutationOptions = getAdminCreateOrganizationProductRegistrationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cursor-paginated change feed of product registrations ordered by (LastSignedInUtc, Id) for sync consumers. Requires Admin role.
 * @summary List product registrations (admin change feed)
 */
export const adminListProductRegistrations = (
  params?: AdminListProductRegistrationsParams,
  signal?: AbortSignal
) => {
  return instance<AdminProductRegistrationsPageResponse>({
    url: `/v1/admin/product-registrations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListProductRegistrationsQueryKey = (
  params?: AdminListProductRegistrationsParams
) => {
  return [`/v1/admin/product-registrations`, ...(params ? [params] : [])] as const;
};

export const getAdminListProductRegistrationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListProductRegistrations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductRegistrations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListProductRegistrationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListProductRegistrations>>> = ({
    signal,
  }) => adminListProductRegistrations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListProductRegistrations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListProductRegistrationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListProductRegistrations>>
>;
export type AdminListProductRegistrationsQueryError = ErrorType<ProblemDetails>;

export function useAdminListProductRegistrations<
  TData = Awaited<ReturnType<typeof adminListProductRegistrations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListProductRegistrationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductRegistrations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductRegistrations>>,
          TError,
          Awaited<ReturnType<typeof adminListProductRegistrations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductRegistrations<
  TData = Awaited<ReturnType<typeof adminListProductRegistrations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductRegistrations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductRegistrations>>,
          TError,
          Awaited<ReturnType<typeof adminListProductRegistrations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductRegistrations<
  TData = Awaited<ReturnType<typeof adminListProductRegistrations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductRegistrations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List product registrations (admin change feed)
 */

export function useAdminListProductRegistrations<
  TData = Awaited<ReturnType<typeof adminListProductRegistrations>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListProductRegistrations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListProductRegistrationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cursor-paginated change feed of product registration history rows (append-only) ordered by (RegisteredAtUtc, Id) for sync consumers. Requires Admin role.
 * @summary List product registration history (admin change feed)
 */
export const adminListProductRegistrationHistory = (
  params?: AdminListProductRegistrationHistoryParams,
  signal?: AbortSignal
) => {
  return instance<AdminProductRegistrationHistoryPageResponse>({
    url: `/v1/admin/product-registration-history`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListProductRegistrationHistoryQueryKey = (
  params?: AdminListProductRegistrationHistoryParams
) => {
  return [`/v1/admin/product-registration-history`, ...(params ? [params] : [])] as const;
};

export const getAdminListProductRegistrationHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListProductRegistrationHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListProductRegistrationHistory>>> = ({
    signal,
  }) => adminListProductRegistrationHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListProductRegistrationHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListProductRegistrationHistory>>
>;
export type AdminListProductRegistrationHistoryQueryError = ErrorType<ProblemDetails>;

export function useAdminListProductRegistrationHistory<
  TData = Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListProductRegistrationHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
          TError,
          Awaited<ReturnType<typeof adminListProductRegistrationHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductRegistrationHistory<
  TData = Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
          TError,
          Awaited<ReturnType<typeof adminListProductRegistrationHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListProductRegistrationHistory<
  TData = Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List product registration history (admin change feed)
 */

export function useAdminListProductRegistrationHistory<
  TData = Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListProductRegistrationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListProductRegistrationHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListProductRegistrationHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new product. Requires Admin role.
 * @summary Create product
 */
export const adminCreateProduct = (
  createProductRequest: CreateProductRequest,
  signal?: AbortSignal
) => {
  return instance<ProductResponse>({
    url: `/v1/admin/products`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createProductRequest,
    signal,
  });
};

export const getAdminCreateProductMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateProduct>>,
    TError,
    { data: CreateProductRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateProduct>>,
  TError,
  { data: CreateProductRequest },
  TContext
> => {
  const mutationKey = ['adminCreateProduct'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateProduct>>,
    { data: CreateProductRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateProduct(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateProduct>>
>;
export type AdminCreateProductMutationBody = CreateProductRequest;
export type AdminCreateProductMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create product
 */
export const useAdminCreateProduct = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateProduct>>,
      TError,
      { data: CreateProductRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateProduct>>,
  TError,
  { data: CreateProductRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all products. Requires Admin role.
 * @summary List products
 */
export const adminGetProducts = (signal?: AbortSignal) => {
  return instance<ProductsListResponse>({ url: `/v1/admin/products`, method: 'GET', signal });
};

export const getAdminGetProductsQueryKey = () => {
  return [`/v1/admin/products`] as const;
};

export const getAdminGetProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProducts>>,
  TError = ErrorType<ProblemDetails>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProducts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetProductsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProducts>>> = ({ signal }) =>
    adminGetProducts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetProducts>>>;
export type AdminGetProductsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetProducts<
  TData = Awaited<ReturnType<typeof adminGetProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProducts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProducts>>,
          TError,
          Awaited<ReturnType<typeof adminGetProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProducts<
  TData = Awaited<ReturnType<typeof adminGetProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProducts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProducts>>,
          TError,
          Awaited<ReturnType<typeof adminGetProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProducts<
  TData = Awaited<ReturnType<typeof adminGetProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProducts>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List products
 */

export function useAdminGetProducts<
  TData = Awaited<ReturnType<typeof adminGetProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProducts>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetProductsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a product by ID. Requires Admin role.
 * @summary Get product
 */
export const adminGetProduct = (productId: string, signal?: AbortSignal) => {
  return instance<ProductResponse>({
    url: `/v1/admin/products/${productId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetProductQueryKey = (productId?: string) => {
  return [`/v1/admin/products/${productId}`] as const;
};

export const getAdminGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProduct>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetProductQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProduct>>> = ({ signal }) =>
    adminGetProduct(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetProductQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetProduct>>>;
export type AdminGetProductQueryError = ErrorType<ProblemDetails>;

export function useAdminGetProduct<
  TData = Awaited<ReturnType<typeof adminGetProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProduct>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProduct>>,
          TError,
          Awaited<ReturnType<typeof adminGetProduct>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProduct<
  TData = Awaited<ReturnType<typeof adminGetProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProduct>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProduct>>,
          TError,
          Awaited<ReturnType<typeof adminGetProduct>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProduct<
  TData = Awaited<ReturnType<typeof adminGetProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProduct>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get product
 */

export function useAdminGetProduct<
  TData = Awaited<ReturnType<typeof adminGetProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetProduct>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetProductQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a product's settings. Requires Admin role.
 * @summary Update product
 */
export const adminUpdateProduct = (
  productId: string,
  updateProductRequest: UpdateProductRequest
) => {
  return instance<ProductResponse>({
    url: `/v1/admin/products/${productId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateProductRequest,
  });
};

export const getAdminUpdateProductMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateProduct>>,
    TError,
    { productId: string; data: UpdateProductRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateProduct>>,
  TError,
  { productId: string; data: UpdateProductRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateProduct'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateProduct>>,
    { productId: string; data: UpdateProductRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminUpdateProduct(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateProduct>>
>;
export type AdminUpdateProductMutationBody = UpdateProductRequest;
export type AdminUpdateProductMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update product
 */
export const useAdminUpdateProduct = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateProduct>>,
      TError,
      { productId: string; data: UpdateProductRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateProduct>>,
  TError,
  { productId: string; data: UpdateProductRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create a new system notice
 */
export const adminCreateSystemNotice = (
  createSystemNoticeRequest: CreateSystemNoticeRequest,
  signal?: AbortSignal
) => {
  return instance<SystemNoticeResponse>({
    url: `/v1/admin/system-notices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSystemNoticeRequest,
    signal,
  });
};

export const getAdminCreateSystemNoticeMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateSystemNotice>>,
    TError,
    { data: CreateSystemNoticeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateSystemNotice>>,
  TError,
  { data: CreateSystemNoticeRequest },
  TContext
> => {
  const mutationKey = ['adminCreateSystemNotice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateSystemNotice>>,
    { data: CreateSystemNoticeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateSystemNotice(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateSystemNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateSystemNotice>>
>;
export type AdminCreateSystemNoticeMutationBody = CreateSystemNoticeRequest;
export type AdminCreateSystemNoticeMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create a new system notice
 */
export const useAdminCreateSystemNotice = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateSystemNotice>>,
      TError,
      { data: CreateSystemNoticeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateSystemNotice>>,
  TError,
  { data: CreateSystemNoticeRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateSystemNoticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List system notices with optional filtering
 */
export const adminListSystemNotices = (
  params?: AdminListSystemNoticesParams,
  signal?: AbortSignal
) => {
  return instance<SystemNoticeResponse[]>({
    url: `/v1/admin/system-notices`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListSystemNoticesQueryKey = (params?: AdminListSystemNoticesParams) => {
  return [`/v1/admin/system-notices`, ...(params ? [params] : [])] as const;
};

export const getAdminListSystemNoticesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListSystemNotices>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListSystemNoticesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListSystemNotices>>> = ({ signal }) =>
    adminListSystemNotices(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListSystemNotices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListSystemNoticesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListSystemNotices>>
>;
export type AdminListSystemNoticesQueryError = ErrorType<ProblemDetails>;

export function useAdminListSystemNotices<
  TData = Awaited<ReturnType<typeof adminListSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListSystemNoticesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListSystemNotices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListSystemNotices>>,
          TError,
          Awaited<ReturnType<typeof adminListSystemNotices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListSystemNotices<
  TData = Awaited<ReturnType<typeof adminListSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListSystemNotices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListSystemNotices>>,
          TError,
          Awaited<ReturnType<typeof adminListSystemNotices>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListSystemNotices<
  TData = Awaited<ReturnType<typeof adminListSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListSystemNotices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List system notices with optional filtering
 */

export function useAdminListSystemNotices<
  TData = Awaited<ReturnType<typeof adminListSystemNotices>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListSystemNoticesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListSystemNotices>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListSystemNoticesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a system notice by ID
 */
export const adminGetSystemNotice = (noticeId: string, signal?: AbortSignal) => {
  return instance<SystemNoticeResponse>({
    url: `/v1/admin/system-notices/${noticeId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetSystemNoticeQueryKey = (noticeId?: string) => {
  return [`/v1/admin/system-notices/${noticeId}`] as const;
};

export const getAdminGetSystemNoticeQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetSystemNotice>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetSystemNoticeQueryKey(noticeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetSystemNotice>>> = ({ signal }) =>
    adminGetSystemNotice(noticeId, signal);

  return { queryKey, queryFn, enabled: !!noticeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetSystemNotice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetSystemNoticeQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetSystemNotice>>
>;
export type AdminGetSystemNoticeQueryError = ErrorType<ProblemDetails>;

export function useAdminGetSystemNotice<
  TData = Awaited<ReturnType<typeof adminGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetSystemNotice>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetSystemNotice>>,
          TError,
          Awaited<ReturnType<typeof adminGetSystemNotice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetSystemNotice<
  TData = Awaited<ReturnType<typeof adminGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetSystemNotice>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetSystemNotice>>,
          TError,
          Awaited<ReturnType<typeof adminGetSystemNotice>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetSystemNotice<
  TData = Awaited<ReturnType<typeof adminGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetSystemNotice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a system notice by ID
 */

export function useAdminGetSystemNotice<
  TData = Awaited<ReturnType<typeof adminGetSystemNotice>>,
  TError = ErrorType<ProblemDetails>,
>(
  noticeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetSystemNotice>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetSystemNoticeQueryOptions(noticeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update an existing system notice
 */
export const adminUpdateSystemNotice = (
  noticeId: string,
  updateSystemNoticeRequest: UpdateSystemNoticeRequest
) => {
  return instance<SystemNoticeResponse>({
    url: `/v1/admin/system-notices/${noticeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateSystemNoticeRequest,
  });
};

export const getAdminUpdateSystemNoticeMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSystemNotice>>,
    TError,
    { noticeId: string; data: UpdateSystemNoticeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateSystemNotice>>,
  TError,
  { noticeId: string; data: UpdateSystemNoticeRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateSystemNotice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateSystemNotice>>,
    { noticeId: string; data: UpdateSystemNoticeRequest }
  > = (props) => {
    const { noticeId, data } = props ?? {};

    return adminUpdateSystemNotice(noticeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateSystemNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateSystemNotice>>
>;
export type AdminUpdateSystemNoticeMutationBody = UpdateSystemNoticeRequest;
export type AdminUpdateSystemNoticeMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update an existing system notice
 */
export const useAdminUpdateSystemNotice = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateSystemNotice>>,
      TError,
      { noticeId: string; data: UpdateSystemNoticeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateSystemNotice>>,
  TError,
  { noticeId: string; data: UpdateSystemNoticeRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateSystemNoticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a system notice (draft only)
 */
export const adminDeleteSystemNotice = (noticeId: string) => {
  return instance<void>({ url: `/v1/admin/system-notices/${noticeId}`, method: 'DELETE' });
};

export const getAdminDeleteSystemNoticeMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteSystemNotice>>,
    TError,
    { noticeId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteSystemNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteSystemNotice'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteSystemNotice>>,
    { noticeId: string }
  > = (props) => {
    const { noticeId } = props ?? {};

    return adminDeleteSystemNotice(noticeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteSystemNoticeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteSystemNotice>>
>;

export type AdminDeleteSystemNoticeMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete a system notice (draft only)
 */
export const useAdminDeleteSystemNotice = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteSystemNotice>>,
      TError,
      { noticeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteSystemNotice>>,
  TError,
  { noticeId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteSystemNoticeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new product trial. Requires Admin role.
 * @summary Create product trial
 */
export const adminCreateProductTrial = (
  productId: string,
  createProductTrialRequest: CreateProductTrialRequest,
  signal?: AbortSignal
) => {
  return instance<ProductTrialResponse>({
    url: `/v1/admin/products/${productId}/trials`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createProductTrialRequest,
    signal,
  });
};

export const getAdminCreateProductTrialMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateProductTrial>>,
    TError,
    { productId: string; data: CreateProductTrialRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateProductTrial>>,
  TError,
  { productId: string; data: CreateProductTrialRequest },
  TContext
> => {
  const mutationKey = ['adminCreateProductTrial'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateProductTrial>>,
    { productId: string; data: CreateProductTrialRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminCreateProductTrial(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateProductTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateProductTrial>>
>;
export type AdminCreateProductTrialMutationBody = CreateProductTrialRequest;
export type AdminCreateProductTrialMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create product trial
 */
export const useAdminCreateProductTrial = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateProductTrial>>,
      TError,
      { productId: string; data: CreateProductTrialRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateProductTrial>>,
  TError,
  { productId: string; data: CreateProductTrialRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateProductTrialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all trials for a product. Requires Admin role.
 * @summary List product trials
 */
export const adminGetProductTrials = (productId: string, signal?: AbortSignal) => {
  return instance<ProductTrialsListResponse>({
    url: `/v1/admin/products/${productId}/trials`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetProductTrialsQueryKey = (productId?: string) => {
  return [`/v1/admin/products/${productId}/trials`] as const;
};

export const getAdminGetProductTrialsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProductTrials>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrials>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetProductTrialsQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProductTrials>>> = ({ signal }) =>
    adminGetProductTrials(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProductTrials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetProductTrialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetProductTrials>>
>;
export type AdminGetProductTrialsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetProductTrials<
  TData = Awaited<ReturnType<typeof adminGetProductTrials>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrials>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductTrials>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductTrials>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductTrials<
  TData = Awaited<ReturnType<typeof adminGetProductTrials>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrials>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductTrials>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductTrials>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductTrials<
  TData = Awaited<ReturnType<typeof adminGetProductTrials>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List product trials
 */

export function useAdminGetProductTrials<
  TData = Awaited<ReturnType<typeof adminGetProductTrials>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetProductTrialsQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a product trial by ID. Requires Admin role.
 * @summary Get product trial
 */
export const adminGetProductTrial = (trialId: string, signal?: AbortSignal) => {
  return instance<ProductTrialResponse>({
    url: `/v1/admin/trials/${trialId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetProductTrialQueryKey = (trialId?: string) => {
  return [`/v1/admin/trials/${trialId}`] as const;
};

export const getAdminGetProductTrialQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetProductTrial>>,
  TError = ErrorType<ProblemDetails>,
>(
  trialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrial>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetProductTrialQueryKey(trialId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetProductTrial>>> = ({ signal }) =>
    adminGetProductTrial(trialId, signal);

  return { queryKey, queryFn, enabled: !!trialId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetProductTrial>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetProductTrialQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetProductTrial>>
>;
export type AdminGetProductTrialQueryError = ErrorType<ProblemDetails>;

export function useAdminGetProductTrial<
  TData = Awaited<ReturnType<typeof adminGetProductTrial>>,
  TError = ErrorType<ProblemDetails>,
>(
  trialId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrial>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductTrial>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductTrial>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductTrial<
  TData = Awaited<ReturnType<typeof adminGetProductTrial>>,
  TError = ErrorType<ProblemDetails>,
>(
  trialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrial>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetProductTrial>>,
          TError,
          Awaited<ReturnType<typeof adminGetProductTrial>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetProductTrial<
  TData = Awaited<ReturnType<typeof adminGetProductTrial>>,
  TError = ErrorType<ProblemDetails>,
>(
  trialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrial>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get product trial
 */

export function useAdminGetProductTrial<
  TData = Awaited<ReturnType<typeof adminGetProductTrial>>,
  TError = ErrorType<ProblemDetails>,
>(
  trialId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetProductTrial>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetProductTrialQueryOptions(trialId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a product trial. Requires Admin role.
 * @summary Delete product trial
 */
export const adminDeleteProductTrial = (trialId: string) => {
  return instance<ProductTrialResponse>({ url: `/v1/admin/trials/${trialId}`, method: 'DELETE' });
};

export const getAdminDeleteProductTrialMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteProductTrial>>,
    TError,
    { trialId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteProductTrial>>,
  TError,
  { trialId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteProductTrial'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteProductTrial>>,
    { trialId: string }
  > = (props) => {
    const { trialId } = props ?? {};

    return adminDeleteProductTrial(trialId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteProductTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteProductTrial>>
>;

export type AdminDeleteProductTrialMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete product trial
 */
export const useAdminDeleteProductTrial = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteProductTrial>>,
      TError,
      { trialId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteProductTrial>>,
  TError,
  { trialId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteProductTrialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cursor-paginated change feed of user-role rows (including pending invitations) ordered by (UpdatedUtc, Id) for sync consumers. Requires Admin role.
 * @summary List user roles (admin change feed)
 */
export const adminListUserRoles = (params?: AdminListUserRolesParams, signal?: AbortSignal) => {
  return instance<AdminUserRolesPageResponse>({
    url: `/v1/admin/user-roles`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListUserRolesQueryKey = (params?: AdminListUserRolesParams) => {
  return [`/v1/admin/user-roles`, ...(params ? [params] : [])] as const;
};

export const getAdminListUserRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUserRoles>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUserRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserRoles>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListUserRolesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUserRoles>>> = ({ signal }) =>
    adminListUserRoles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUserRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListUserRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListUserRoles>>
>;
export type AdminListUserRolesQueryError = ErrorType<ProblemDetails>;

export function useAdminListUserRoles<
  TData = Awaited<ReturnType<typeof adminListUserRoles>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListUserRolesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserRoles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUserRoles>>,
          TError,
          Awaited<ReturnType<typeof adminListUserRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListUserRoles<
  TData = Awaited<ReturnType<typeof adminListUserRoles>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUserRolesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminListUserRoles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUserRoles>>,
          TError,
          Awaited<ReturnType<typeof adminListUserRoles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListUserRoles<
  TData = Awaited<ReturnType<typeof adminListUserRoles>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUserRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserRoles>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List user roles (admin change feed)
 */

export function useAdminListUserRoles<
  TData = Awaited<ReturnType<typeof adminListUserRoles>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUserRolesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUserRoles>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListUserRolesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cursor-paginated change feed of users ordered by (UpdatedUtc, Id) for sync consumers. Supports an optional exact-match email filter. Requires Admin role.
 * @summary List users (admin change feed)
 */
export const adminListUsers = (params?: AdminListUsersParams, signal?: AbortSignal) => {
  return instance<AdminUsersPageResponse>({
    url: `/v1/admin/users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminListUsersQueryKey = (params?: AdminListUsersParams) => {
  return [`/v1/admin/users`, ...(params ? [params] : [])] as const;
};

export const getAdminListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListUsers>>> = ({ signal }) =>
    adminListUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminListUsers>>>;
export type AdminListUsersQueryError = ErrorType<ProblemDetails>;

export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminListUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUsers>>,
          TError,
          Awaited<ReturnType<typeof adminListUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListUsers>>,
          TError,
          Awaited<ReturnType<typeof adminListUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List users (admin change feed)
 */

export function useAdminListUsers<
  TData = Awaited<ReturnType<typeof adminListUsers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminListUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a consultant hour package for a product, mapping a synced, active, one-time Stripe price to the hours credited per purchase. Packages are created active. The price must be synced from Stripe first. Requires Admin role.
 * @summary Create consultant hour package
 */
export const adminCreateConsultantHourPackage = (
  productId: string,
  createConsultantHourPackageRequest: CreateConsultantHourPackageRequest,
  signal?: AbortSignal
) => {
  return instance<ConsultantHourPackageResponse>({
    url: `/v1/admin/products/${productId}/consultant-hour-packages`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createConsultantHourPackageRequest,
    signal,
  });
};

export const getAdminCreateConsultantHourPackageMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>,
    TError,
    { productId: string; data: CreateConsultantHourPackageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>,
  TError,
  { productId: string; data: CreateConsultantHourPackageRequest },
  TContext
> => {
  const mutationKey = ['adminCreateConsultantHourPackage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>,
    { productId: string; data: CreateConsultantHourPackageRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminCreateConsultantHourPackage(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateConsultantHourPackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>
>;
export type AdminCreateConsultantHourPackageMutationBody = CreateConsultantHourPackageRequest;
export type AdminCreateConsultantHourPackageMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create consultant hour package
 */
export const useAdminCreateConsultantHourPackage = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>,
      TError,
      { productId: string; data: CreateConsultantHourPackageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateConsultantHourPackage>>,
  TError,
  { productId: string; data: CreateConsultantHourPackageRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateConsultantHourPackageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Lists every consultant hour package of a product, active or not, ordered by sort order then hours, with each package's Stripe price amount, currency and status. Requires Admin role.
 * @summary List consultant hour packages
 */
export const adminGetConsultantHourPackages = (productId: string, signal?: AbortSignal) => {
  return instance<ConsultantHourPackagesListResponse>({
    url: `/v1/admin/products/${productId}/consultant-hour-packages`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetConsultantHourPackagesQueryKey = (productId?: string) => {
  return [`/v1/admin/products/${productId}/consultant-hour-packages`] as const;
};

export const getAdminGetConsultantHourPackagesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetConsultantHourPackagesQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>> = ({
    signal,
  }) => adminGetConsultantHourPackages(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetConsultantHourPackagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetConsultantHourPackages>>
>;
export type AdminGetConsultantHourPackagesQueryError = ErrorType<ProblemDetails>;

export function useAdminGetConsultantHourPackages<
  TData = Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHourPackages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHourPackages<
  TData = Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
          TError,
          Awaited<ReturnType<typeof adminGetConsultantHourPackages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetConsultantHourPackages<
  TData = Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List consultant hour packages
 */

export function useAdminGetConsultantHourPackages<
  TData = Awaited<ReturnType<typeof adminGetConsultantHourPackages>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetConsultantHourPackages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetConsultantHourPackagesQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Applies a partial update to a package's display name, hours, active flag and sort order. The Stripe price cannot be changed; create a new package and deactivate this one instead. Hours changes apply to checkouts started afterwards. Packages are retired by setting active to false rather than deleted, since ledger entries reference them. Requires Admin role.
 * @summary Update consultant hour package
 */
export const adminUpdateConsultantHourPackage = (
  productId: string,
  packageId: string,
  updateConsultantHourPackageRequest: UpdateConsultantHourPackageRequest
) => {
  return instance<ConsultantHourPackageResponse>({
    url: `/v1/admin/products/${productId}/consultant-hour-packages/${packageId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateConsultantHourPackageRequest,
  });
};

export const getAdminUpdateConsultantHourPackageMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>,
    TError,
    { productId: string; packageId: string; data: UpdateConsultantHourPackageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>,
  TError,
  { productId: string; packageId: string; data: UpdateConsultantHourPackageRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateConsultantHourPackage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>,
    { productId: string; packageId: string; data: UpdateConsultantHourPackageRequest }
  > = (props) => {
    const { productId, packageId, data } = props ?? {};

    return adminUpdateConsultantHourPackage(productId, packageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateConsultantHourPackageMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>
>;
export type AdminUpdateConsultantHourPackageMutationBody = UpdateConsultantHourPackageRequest;
export type AdminUpdateConsultantHourPackageMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update consultant hour package
 */
export const useAdminUpdateConsultantHourPackage = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>,
      TError,
      { productId: string; packageId: string; data: UpdateConsultantHourPackageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateConsultantHourPackage>>,
  TError,
  { productId: string; packageId: string; data: UpdateConsultantHourPackageRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateConsultantHourPackageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets a paginated list of all Stripe customers. Requires Admin role.
 * @summary List Stripe customers
 */
export const adminGetStripeCustomers = (
  params?: AdminGetStripeCustomersParams,
  signal?: AbortSignal
) => {
  return instance<StripeCustomersListResponse>({
    url: `/v1/admin/stripe-customers`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetStripeCustomersQueryKey = (params?: AdminGetStripeCustomersParams) => {
  return [`/v1/admin/stripe-customers`, ...(params ? [params] : [])] as const;
};

export const getAdminGetStripeCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeCustomers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeCustomers>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeCustomersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeCustomers>>> = ({
    signal,
  }) => adminGetStripeCustomers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeCustomers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeCustomers>>
>;
export type AdminGetStripeCustomersQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeCustomers<
  TData = Awaited<ReturnType<typeof adminGetStripeCustomers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminGetStripeCustomersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeCustomers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeCustomers>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeCustomers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeCustomers<
  TData = Awaited<ReturnType<typeof adminGetStripeCustomers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeCustomers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeCustomers>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeCustomers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeCustomers<
  TData = Awaited<ReturnType<typeof adminGetStripeCustomers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeCustomers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stripe customers
 */

export function useAdminGetStripeCustomers<
  TData = Awaited<ReturnType<typeof adminGetStripeCustomers>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeCustomersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeCustomers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeCustomersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Starts an orchestration to synchronize all customers from Stripe to the local database. Only customers with valid user_id or organization_id metadata are synced. Returns immediately with a status URL to check progress. Requires Admin role.
 * @summary Sync Stripe customers
 */
export const adminSyncStripeCustomers = (signal?: AbortSignal) => {
  return instance<StripeSyncOrchestrationStatus>({
    url: `/v1/admin/stripe-customers/sync`,
    method: 'POST',
    signal,
  });
};

export const getAdminSyncStripeCustomersMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSyncStripeCustomers>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSyncStripeCustomers>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminSyncStripeCustomers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSyncStripeCustomers>>,
    void
  > = () => {
    return adminSyncStripeCustomers();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSyncStripeCustomersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSyncStripeCustomers>>
>;

export type AdminSyncStripeCustomersMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Sync Stripe customers
 */
export const useAdminSyncStripeCustomers = <TError = ErrorType<ProblemDetails>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSyncStripeCustomers>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSyncStripeCustomers>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAdminSyncStripeCustomersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts an orchestration to synchronize a specific customer from Stripe to the local database. Only syncs if the customer has valid user_id or organization_id metadata. Returns immediately with a status URL to check progress. Requires Admin role.
 * @summary Sync a specific Stripe customer
 */
export const adminSyncStripeCustomerById = (customerId: string, signal?: AbortSignal) => {
  return instance<StripeSyncOrchestrationStatus>({
    url: `/v1/admin/stripe-customers/${customerId}/sync`,
    method: 'POST',
    signal,
  });
};

export const getAdminSyncStripeCustomerByIdMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSyncStripeCustomerById>>,
    TError,
    { customerId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSyncStripeCustomerById>>,
  TError,
  { customerId: string },
  TContext
> => {
  const mutationKey = ['adminSyncStripeCustomerById'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSyncStripeCustomerById>>,
    { customerId: string }
  > = (props) => {
    const { customerId } = props ?? {};

    return adminSyncStripeCustomerById(customerId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSyncStripeCustomerByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSyncStripeCustomerById>>
>;

export type AdminSyncStripeCustomerByIdMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Sync a specific Stripe customer
 */
export const useAdminSyncStripeCustomerById = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSyncStripeCustomerById>>,
      TError,
      { customerId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSyncStripeCustomerById>>,
  TError,
  { customerId: string },
  TContext
> => {
  const mutationOptions = getAdminSyncStripeCustomerByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts an orchestration to synchronize the Stripe customer associated with a specific user. Returns immediately with a status URL to check progress. Requires Admin role.
 * @summary Sync Stripe customer by user ID
 */
export const adminSyncStripeCustomerByUserId = (userId: string, signal?: AbortSignal) => {
  return instance<StripeSyncOrchestrationStatus>({
    url: `/v1/admin/stripe-customers/sync/user/${userId}`,
    method: 'POST',
    signal,
  });
};

export const getAdminSyncStripeCustomerByUserIdMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminSyncStripeCustomerByUserId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return adminSyncStripeCustomerByUserId(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSyncStripeCustomerByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>
>;

export type AdminSyncStripeCustomerByUserIdMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Sync Stripe customer by user ID
 */
export const useAdminSyncStripeCustomerByUserId = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByUserId>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getAdminSyncStripeCustomerByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Starts an orchestration to synchronize the Stripe customer associated with a specific organization. Returns immediately with a status URL to check progress. Requires Admin role.
 * @summary Sync Stripe customer by organization ID
 */
export const adminSyncStripeCustomerByOrganizationId = (
  organizationId: string,
  signal?: AbortSignal
) => {
  return instance<StripeSyncOrchestrationStatus>({
    url: `/v1/admin/stripe-customers/sync/organization/${organizationId}`,
    method: 'POST',
    signal,
  });
};

export const getAdminSyncStripeCustomerByOrganizationIdMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>,
    TError,
    { organizationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>,
  TError,
  { organizationId: string },
  TContext
> => {
  const mutationKey = ['adminSyncStripeCustomerByOrganizationId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>,
    { organizationId: string }
  > = (props) => {
    const { organizationId } = props ?? {};

    return adminSyncStripeCustomerByOrganizationId(organizationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSyncStripeCustomerByOrganizationIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>
>;

export type AdminSyncStripeCustomerByOrganizationIdMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Sync Stripe customer by organization ID
 */
export const useAdminSyncStripeCustomerByOrganizationId = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>,
      TError,
      { organizationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminSyncStripeCustomerByOrganizationId>>,
  TError,
  { organizationId: string },
  TContext
> => {
  const mutationOptions = getAdminSyncStripeCustomerByOrganizationIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a new Stripe price to product mapping with entitlement rule. Requires Admin role.
 * @summary Create Stripe price entitlement mapping
 */
export const adminCreateStripePriceEntitlement = (
  productId: string,
  createStripePriceEntitlementRequest: CreateStripePriceEntitlementRequest,
  signal?: AbortSignal
) => {
  return instance<StripePriceEntitlementResponse>({
    url: `/v1/admin/products/${productId}/stripe-price-entitlements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createStripePriceEntitlementRequest,
    signal,
  });
};

export const getAdminCreateStripePriceEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>,
    TError,
    { productId: string; data: CreateStripePriceEntitlementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>,
  TError,
  { productId: string; data: CreateStripePriceEntitlementRequest },
  TContext
> => {
  const mutationKey = ['adminCreateStripePriceEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>,
    { productId: string; data: CreateStripePriceEntitlementRequest }
  > = (props) => {
    const { productId, data } = props ?? {};

    return adminCreateStripePriceEntitlement(productId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateStripePriceEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>
>;
export type AdminCreateStripePriceEntitlementMutationBody = CreateStripePriceEntitlementRequest;
export type AdminCreateStripePriceEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create Stripe price entitlement mapping
 */
export const useAdminCreateStripePriceEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>,
      TError,
      { productId: string; data: CreateStripePriceEntitlementRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateStripePriceEntitlement>>,
  TError,
  { productId: string; data: CreateStripePriceEntitlementRequest },
  TContext
> => {
  const mutationOptions = getAdminCreateStripePriceEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets all Stripe price entitlement mappings for a product. Requires Admin role.
 * @summary List Stripe price entitlement mappings
 */
export const adminGetStripePriceEntitlements = (productId: string, signal?: AbortSignal) => {
  return instance<StripePriceEntitlementsListResponse>({
    url: `/v1/admin/products/${productId}/stripe-price-entitlements`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetStripePriceEntitlementsQueryKey = (productId?: string) => {
  return [`/v1/admin/products/${productId}/stripe-price-entitlements`] as const;
};

export const getAdminGetStripePriceEntitlementsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripePriceEntitlementsQueryKey(productId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>> = ({
    signal,
  }) => adminGetStripePriceEntitlements(productId, signal);

  return { queryKey, queryFn, enabled: !!productId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripePriceEntitlementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>
>;
export type AdminGetStripePriceEntitlementsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripePriceEntitlements<
  TData = Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripePriceEntitlements<
  TData = Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripePriceEntitlements<
  TData = Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stripe price entitlement mappings
 */

export function useAdminGetStripePriceEntitlements<
  TData = Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>,
  TError = ErrorType<ProblemDetails>,
>(
  productId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripePriceEntitlements>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripePriceEntitlementsQueryOptions(productId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the entitlement rule for a Stripe price entitlement mapping. Requires Admin role.
 * @summary Update Stripe price entitlement mapping
 */
export const adminUpdateStripePriceEntitlement = (
  productId: string,
  stripePriceId: string,
  updateStripePriceEntitlementRequest: UpdateStripePriceEntitlementRequest
) => {
  return instance<StripePriceEntitlementResponse>({
    url: `/v1/admin/products/${productId}/stripe-price-entitlements/${stripePriceId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateStripePriceEntitlementRequest,
  });
};

export const getAdminUpdateStripePriceEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>,
    TError,
    { productId: string; stripePriceId: string; data: UpdateStripePriceEntitlementRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>,
  TError,
  { productId: string; stripePriceId: string; data: UpdateStripePriceEntitlementRequest },
  TContext
> => {
  const mutationKey = ['adminUpdateStripePriceEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>,
    { productId: string; stripePriceId: string; data: UpdateStripePriceEntitlementRequest }
  > = (props) => {
    const { productId, stripePriceId, data } = props ?? {};

    return adminUpdateStripePriceEntitlement(productId, stripePriceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateStripePriceEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>
>;
export type AdminUpdateStripePriceEntitlementMutationBody = UpdateStripePriceEntitlementRequest;
export type AdminUpdateStripePriceEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Update Stripe price entitlement mapping
 */
export const useAdminUpdateStripePriceEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>,
      TError,
      { productId: string; stripePriceId: string; data: UpdateStripePriceEntitlementRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateStripePriceEntitlement>>,
  TError,
  { productId: string; stripePriceId: string; data: UpdateStripePriceEntitlementRequest },
  TContext
> => {
  const mutationOptions = getAdminUpdateStripePriceEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a Stripe price entitlement mapping. Requires Admin role.
 * @summary Delete Stripe price entitlement mapping
 */
export const adminDeleteStripePriceEntitlement = (productId: string, stripePriceId: string) => {
  return instance<void>({
    url: `/v1/admin/products/${productId}/stripe-price-entitlements/${stripePriceId}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteStripePriceEntitlementMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>,
    TError,
    { productId: string; stripePriceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>,
  TError,
  { productId: string; stripePriceId: string },
  TContext
> => {
  const mutationKey = ['adminDeleteStripePriceEntitlement'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>,
    { productId: string; stripePriceId: string }
  > = (props) => {
    const { productId, stripePriceId } = props ?? {};

    return adminDeleteStripePriceEntitlement(productId, stripePriceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteStripePriceEntitlementMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>
>;

export type AdminDeleteStripePriceEntitlementMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete Stripe price entitlement mapping
 */
export const useAdminDeleteStripePriceEntitlement = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>,
      TError,
      { productId: string; stripePriceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteStripePriceEntitlement>>,
  TError,
  { productId: string; stripePriceId: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteStripePriceEntitlementMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieves all Stripe products synced from Stripe with their prices and localizations.
 * @summary Get all Stripe products
 */
export const adminGetStripeProducts = (
  params?: AdminGetStripeProductsParams,
  signal?: AbortSignal
) => {
  return instance<StripeProductsListResponse>({
    url: `/v1/admin/stripe/products`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetStripeProductsQueryKey = (params?: AdminGetStripeProductsParams) => {
  return [`/v1/admin/stripe/products`, ...(params ? [params] : [])] as const;
};

export const getAdminGetStripeProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProducts>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeProductsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeProducts>>> = ({ signal }) =>
    adminGetStripeProducts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeProducts>>
>;
export type AdminGetStripeProductsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeProducts<
  TData = Awaited<ReturnType<typeof adminGetStripeProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminGetStripeProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProducts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProducts>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProducts<
  TData = Awaited<ReturnType<typeof adminGetStripeProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProducts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProducts>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProducts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProducts<
  TData = Awaited<ReturnType<typeof adminGetStripeProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all Stripe products
 */

export function useAdminGetStripeProducts<
  TData = Awaited<ReturnType<typeof adminGetStripeProducts>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProducts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeProductsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a single Stripe product with its prices and localizations.
 * @summary Get a Stripe product
 */
export const adminGetStripeProduct = (stripeProductId: string, signal?: AbortSignal) => {
  return instance<StripeProductResponse>({
    url: `/v1/admin/stripe/products/${stripeProductId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetStripeProductQueryKey = (stripeProductId?: string) => {
  return [`/v1/admin/stripe/products/${stripeProductId}`] as const;
};

export const getAdminGetStripeProductQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  stripeProductId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProduct>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeProductQueryKey(stripeProductId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeProduct>>> = ({ signal }) =>
    adminGetStripeProduct(stripeProductId, signal);

  return { queryKey, queryFn, enabled: !!stripeProductId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeProduct>>
>;
export type AdminGetStripeProductQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeProduct<
  TData = Awaited<ReturnType<typeof adminGetStripeProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  stripeProductId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProduct>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProduct>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProduct>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProduct<
  TData = Awaited<ReturnType<typeof adminGetStripeProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  stripeProductId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProduct>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProduct>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProduct>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProduct<
  TData = Awaited<ReturnType<typeof adminGetStripeProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  stripeProductId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a Stripe product
 */

export function useAdminGetStripeProduct<
  TData = Awaited<ReturnType<typeof adminGetStripeProduct>>,
  TError = ErrorType<ProblemDetails>,
>(
  stripeProductId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProduct>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeProductQueryOptions(stripeProductId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates or updates a localization for a Stripe product.
 * @summary Create or update a product localization
 */
export const adminUpsertStripeProductLocalization = (
  stripeProductId: string,
  upsertStripeProductLocalizationRequest: UpsertStripeProductLocalizationRequest
) => {
  return instance<StripeProductLocalizationResponse>({
    url: `/v1/admin/stripe/products/${stripeProductId}/localizations`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: upsertStripeProductLocalizationRequest,
  });
};

export const getAdminUpsertStripeProductLocalizationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>,
    TError,
    { stripeProductId: string; data: UpsertStripeProductLocalizationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>,
  TError,
  { stripeProductId: string; data: UpsertStripeProductLocalizationRequest },
  TContext
> => {
  const mutationKey = ['adminUpsertStripeProductLocalization'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>,
    { stripeProductId: string; data: UpsertStripeProductLocalizationRequest }
  > = (props) => {
    const { stripeProductId, data } = props ?? {};

    return adminUpsertStripeProductLocalization(stripeProductId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpsertStripeProductLocalizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>
>;
export type AdminUpsertStripeProductLocalizationMutationBody =
  UpsertStripeProductLocalizationRequest;
export type AdminUpsertStripeProductLocalizationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Create or update a product localization
 */
export const useAdminUpsertStripeProductLocalization = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>,
      TError,
      { stripeProductId: string; data: UpsertStripeProductLocalizationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpsertStripeProductLocalization>>,
  TError,
  { stripeProductId: string; data: UpsertStripeProductLocalizationRequest },
  TContext
> => {
  const mutationOptions = getAdminUpsertStripeProductLocalizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a localization for a Stripe product.
 * @summary Delete a product localization
 */
export const adminDeleteStripeProductLocalization = (stripeProductId: string, language: string) => {
  return instance<void>({
    url: `/v1/admin/stripe/products/${stripeProductId}/localizations/${language}`,
    method: 'DELETE',
  });
};

export const getAdminDeleteStripeProductLocalizationMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>,
    TError,
    { stripeProductId: string; language: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>,
  TError,
  { stripeProductId: string; language: string },
  TContext
> => {
  const mutationKey = ['adminDeleteStripeProductLocalization'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>,
    { stripeProductId: string; language: string }
  > = (props) => {
    const { stripeProductId, language } = props ?? {};

    return adminDeleteStripeProductLocalization(stripeProductId, language);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteStripeProductLocalizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>
>;

export type AdminDeleteStripeProductLocalizationMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Delete a product localization
 */
export const useAdminDeleteStripeProductLocalization = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>,
      TError,
      { stripeProductId: string; language: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteStripeProductLocalization>>,
  TError,
  { stripeProductId: string; language: string },
  TContext
> => {
  const mutationOptions = getAdminDeleteStripeProductLocalizationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Triggers a full sync of all Stripe products and their prices from Stripe.
 * @summary Trigger Stripe product sync
 */
export const adminTriggerStripeProductSync = (signal?: AbortSignal) => {
  return instance<SyncTriggeredResponse>({
    url: `/v1/admin/stripe/products/sync`,
    method: 'POST',
    signal,
  });
};

export const getAdminTriggerStripeProductSyncMutationOptions = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminTriggerStripeProductSync>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminTriggerStripeProductSync>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminTriggerStripeProductSync'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminTriggerStripeProductSync>>,
    void
  > = () => {
    return adminTriggerStripeProductSync();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTriggerStripeProductSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminTriggerStripeProductSync>>
>;

export type AdminTriggerStripeProductSyncMutationError = ErrorType<ProblemDetails>;

/**
 * @summary Trigger Stripe product sync
 */
export const useAdminTriggerStripeProductSync = <
  TError = ErrorType<ProblemDetails>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminTriggerStripeProductSync>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminTriggerStripeProductSync>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAdminTriggerStripeProductSyncMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Gets the status of a Stripe product sync orchestration.
 * @summary Get product sync status
 */
export const adminGetStripeProductSyncStatus = (instanceId: string, signal?: AbortSignal) => {
  return instance<SyncStatusResponse>({
    url: `/v1/admin/stripe/products/sync/${instanceId}/status`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetStripeProductSyncStatusQueryKey = (instanceId?: string) => {
  return [`/v1/admin/stripe/products/sync/${instanceId}/status`] as const;
};

export const getAdminGetStripeProductSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeProductSyncStatusQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>> = ({
    signal,
  }) => adminGetStripeProductSyncStatus(instanceId, signal);

  return { queryKey, queryFn, enabled: !!instanceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeProductSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>
>;
export type AdminGetStripeProductSyncStatusQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeProductSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProductSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeProductSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get product sync status
 */

export function useAdminGetStripeProductSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeProductSyncStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeProductSyncStatusQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a paginated list of all Stripe subscriptions. Requires Admin role.
 * @summary List Stripe subscriptions
 */
export const adminGetStripeSubscriptions = (
  params?: AdminGetStripeSubscriptionsParams,
  signal?: AbortSignal
) => {
  return instance<StripeSubscriptionsListResponse>({
    url: `/v1/admin/stripe-subscriptions`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminGetStripeSubscriptionsQueryKey = (
  params?: AdminGetStripeSubscriptionsParams
) => {
  return [`/v1/admin/stripe-subscriptions`, ...(params ? [params] : [])] as const;
};

export const getAdminGetStripeSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeSubscriptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeSubscriptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>> = ({
    signal,
  }) => adminGetStripeSubscriptions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeSubscriptions>>
>;
export type AdminGetStripeSubscriptionsQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeSubscriptions<
  TData = Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | AdminGetStripeSubscriptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeSubscriptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeSubscriptions<
  TData = Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeSubscriptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeSubscriptions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeSubscriptions<
  TData = Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeSubscriptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Stripe subscriptions
 */

export function useAdminGetStripeSubscriptions<
  TData = Awaited<ReturnType<typeof adminGetStripeSubscriptions>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: AdminGetStripeSubscriptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSubscriptions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeSubscriptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the status of a Stripe sync orchestration. Requires Admin role.
 * @summary Get sync status
 */
export const adminGetStripeSyncStatus = (instanceId: string, signal?: AbortSignal) => {
  return instance<StripeSyncOrchestrationStatus>({
    url: `/v1/admin/stripe-sync/${instanceId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminGetStripeSyncStatusQueryKey = (instanceId?: string) => {
  return [`/v1/admin/stripe-sync/${instanceId}`] as const;
};

export const getAdminGetStripeSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetStripeSyncStatusQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>> = ({
    signal,
  }) => adminGetStripeSyncStatus(instanceId, signal);

  return { queryKey, queryFn, enabled: !!instanceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetStripeSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetStripeSyncStatus>>
>;
export type AdminGetStripeSyncStatusQueryError = ErrorType<ProblemDetails>;

export function useAdminGetStripeSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeSyncStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetStripeSyncStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetStripeSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get sync status
 */

export function useAdminGetStripeSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetStripeSyncStatus>>,
  TError = ErrorType<ProblemDetails>,
>(
  instanceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetStripeSyncStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetStripeSyncStatusQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
